document.res_fr = {
	// ── PL.tip: la boite a en-tete est construite en JS (avant #{global.tip}) ──
	tipHeader_title: "Conseil",
	// le × de l'astuce en mode guide (js/pl/tip.js) — aria-label seulement
	tipClose_label: "Fermer",
	touchRotateHint_body: "Tournez la tablette à l'horizontale : un panneau latéral tient alors à côté de la page.",
	touchRotateHintClose_label: "Fermer",
	// ── Touch layer: the tap copy (tablet-support-plan.md §7b, S7) ──
	// js/touch/copy.js reads <key>_touch in place of <key> on a touch device (seam T-16, util.js
	// getRes). Same meaning, the finger's verb; a line that offered Enter/Esc as the other way drops it.
	obTourWlAdd_body_touch: "Touchez ce bouton et choisissez une liste : le mot y est ajouté directement. Les listes de mots servent à rassembler exactement les mots à apprendre et à travailler.",
	obTourMyList_body_touch: "Tous les mots et expressions ajoutés à votre liste de mots se trouvent ici. Touchez-la pour ouvrir la liste.",
	obTourBandAdd_body_touch: "Chaque liste en possède un : il fait passer des mots de la liste vers le plateau. Touchez-le.",
	obTourBandFive_body_touch: "Touchez la petite flèche à côté du 5 : cinq mots sont tirés au hasard.",
	obWlOffer_body_touch: "Tout est prêt : touchez « Apprendre ! » et apprenez vos nouveaux mots.\n\nMais avant de poursuivre, laissez-moi vous montrer les listes de mots d’un peu plus près. Il y a beaucoup à y découvrir ! Vous pourrez aussi faire la visite des listes de mots plus tard, depuis le menu d’aide {?}.\n\nVoulez-vous continuer la visite ?",
	obWlGarden_body_touch: "Chaque mot planté pousse ici, classé selon votre degré de connaissance. Touchez Mon jardin pour l’ouvrir.",
	obWlLevels_body_touch: "Tous les mots du dictionnaire sont répartis en listes par niveau, des plus faciles aux plus difficiles. Touchez une liste pour l’ouvrir et voir ses mots.",
	obWlTopicPick_body_touch: "Dix-huit listes derrière une seule ligne — nourriture, voyages, travail, et tout le reste. Touchez celle qui est en surbrillance pour l’ouvrir.",
	obWlTopicWord_body_touch: "Touchez un mot dans n’importe quelle liste de mots pour voir son article de dictionnaire. Essayez celui qui est en surbrillance.",
	obWlFilter_body_touch: "Touchez la loupe pour trouver rapidement des mots dans toutes vos listes de mots.",
	obWlNew_body_touch: "Touchez ce bouton pour créer une nouvelle liste de mots — rassemblez-y les mots par leçon, par chanson, par thème, comme vous voulez.",
	obWlNewUse_body_touch: "La prochaine fois que vous toucherez {0} pour un mot à conserver, vous pourrez l’envoyer vers cette liste.",
	obMeetReveal_body_touch: "Essayez de deviner, puis touchez l’invite pour voir ce que le mot signifie.",
	obTourRowOpen_touch: "Touchez le mot pour ouvrir son article — le bouton qui l’envoie vers Apprendre s’y trouve.",
	obMeetEntry_body_touch: "Chaque mot que vous découvrez est accompagné d’un article de dictionnaire complet : sens, grammaire, exemples et prononciation. La traduction est en haut, le reste en dessous. Maintenez le doigt sur un mot ou une étiquette pour voir ce qu’il signifie.",
	obMeetGotIt_body_touch: "Touchez « {0} » une fois la lecture terminée.",
	obTipExpStart_body_touch: "<p>Touchez « Apprendre ! » pour découvrir vos premiers mots — tirés au hasard dans votre niveau pour cette première séance. Par la suite, vous choisirez vous-même les mots que vous voulez.</p><p>Une chose encore : pendant la visite, la plus grande partie de l’application est volontairement hors de portée, pour que rien ne détourne du chemin le plus simple. Ensuite, tout est bien sûr à vous.</p>",
	obTipExpList_body_touch: "Touchez cette liste de mots du dictionnaire pour l’ouvrir.",
	obTipExpChip_body_touch: "Touchez cette lettre pour ouvrir la liste de mots la plus facile du dictionnaire.",
	obTipExpAdd_body_touch: "Ce bouton ajoute des mots de la liste ouverte à votre plateau d’apprentissage — touchez-le, puis choisissez combien.",
	obGuideFive_body_touch: "Touchez la petite flèche et 3 mots tirés au hasard arrivent sur votre plateau d’apprentissage.",
	obGuideFiveNext_body_touch: "Touchez la petite flèche et 5 mots tirés au hasard arrivent sur votre plateau d’apprentissage.",
	obGuideDrill_body_touch: "Touchez « Démarrer l’exercice ! » — une courte séance chronométrée fixera ces mots.",
	obTipSpacePron_body_touch: "Touchez le bouton haut-parleur pour entendre la prononciation du mot. Il apparaît partout où le mot peut être écouté.",
	obTipThirsty_body_touch: "Certaines de vos plantes sont à arroser. Touchez la pastille pour mettre précisément ces mots sur le plateau et faire un tour d’arrosage rapide.",
	learnStudyTerm_tooltip_touch: "Touchez pour ouvrir l’article de dictionnaire de ce mot",
	learnMeet_reveal_label_touch: "Vous connaissez la traduction ? Touchez ici pour l’afficher",
	learnQ_pickHint_touch: "Touchez la bonne carte",
	stopButton_tooltip_touch: "Touchez pour arrêter l’exercice et revenir à la page principale",
	phraseBand_pagerRow_tooltip_touch: "Lignes {0}–{1} sur {2} — touchez pour y aller",
	startButton_tooltip_touch: "Touchez pour apprendre des mots !",
	practiceDir_mix_tooltip_touch: "Activez les deux directions pour une séance mixte : chaque mot part dans le sens INVERSE de la dernière fois<p/>(la série garde la même longueur — une carte par mot)",
	pauseButton_tooltip_touch: "Touchez pour suspendre l’apprentissage des mots",
	continueButton_tooltip_touch: "Touchez pour poursuivre l’apprentissage des mots",
	richTerm_tooltip_touch: "Touchez pour replier — ou utilisez le bouton Retour du navigateur pour quitter cette vue",
	revealTerm_tooltip_touch: "Touchez pour ouvrir l’article de dictionnaire",
	pronDialPlay_hint_touch: "touchez pour écouter",
	wlGarden_tooltip_touch: "Tous les mots que vous avez réellement abordés — ce qui est à arroser, ce que vous avez commencé et ce qui pousse<p/>Touchez la fleur pour voir tout le jardin",
	wlLevelSort_tooltip_touch: "Ordre de cette liste — touchez pour changer",
	wlLevelCompactHint_tooltip_touch: "<p>Touchez deux fois : replier les lignes de niveau en une seule bande.</p><p>Touchez deux fois le 📖 pour déplier.</p><p>Aussi : menu du compte ▸ Paramètres ▸ Paramètres des listes de mots.</p>",
	wlLevelExpandHint_tooltip_touch: "<p>Touchez deux fois : déplier, une ligne par niveau.</p><p>Touchez deux fois le 📖 d’une ligne pour replier.</p><p>Touchez une lettre pour ouvrir cette liste.</p><p>Aussi : menu du compte ▸ Paramètres ▸ Paramètres des listes de mots.</p>",
	wlVerbCompactHint_tooltip_touch: "<p>Touchez deux fois : replier les lignes de verbes en une seule bande.</p><p>Touchez deux fois le 📝 pour déplier.</p><p>Aussi : menu du compte ▸ Paramètres ▸ Paramètres des listes de mots.</p>",
	wlVerbExpandHint_tooltip_touch: "<p>Touchez deux fois : déplier, une ligne par liste.</p><p>Touchez deux fois l’icône d’une ligne pour replier.</p><p>Touchez une icône pour ouvrir cette liste.</p><p>Aussi : menu du compte ▸ Paramètres ▸ Paramètres des listes de mots.</p>",
	richTopicHint_tooltip_touch: "(touchez pour ouvrir la liste de mots de ce thème)",
	knownToggle_tooltip_touch: "Marquer ce sens comme déjà connu — les exercices l’ignorent (touchez à nouveau pour annuler)",
	exGroup_recalled_tooltip_touch: "Vous avez produit ces mots au niveau que vous avez vous-même fixé avec le curseur du niveau d’exigence. Touchez les mots pour voir ou modifier la position de ce curseur — c’est la seule chose qui détermine dans quel groupe un mot atterrit.",
	exGroup_notRecalled_tooltip_touch: "Ces mots ne sont pas revenus au niveau que vous avez vous-même fixé avec le curseur du niveau d’exigence. Rien n’est perdu et aucune plante ne régresse jamais — ces mots reviennent simplement plus tôt. Touchez les mots pour voir ou modifier la position de ce curseur.",
	garden_stats_click_hint_touch: "Touchez pour les statistiques de ce mot",
	garden_grow_open_touch: "Touchez pour voir tout votre jardin",
	garden_thirsty_tooltip_touch: "Mots à arroser<p/>Touchez pour les mettre sur le plateau de pratique",
	garden_vista_click_hint_touch: "Touchez pour l’article complet",
	hist_tip_word_touch: "Le mot dont il est question dans cette ligne. Touchez la ligne pour voir tout son historique d’apprentissage.",
	hist_ws_tip_word_touch: "Le mot dont il est question sur cette ligne. Touchez la ligne pour voir son historique complet.",
	hist_wh_tip_when_touch: "La séance qui a travaillé ce mot — son jour et son heure de début. Touchez la ligne pour ouvrir cette séance.",
	hist_acc_hard_sub_touch: "précision la plus faible, parmi les mots vus au moins {0} fois — touchez un mot pour voir tout son historique",
	// ── end of the tap copy ──
	tipMakeSmall_label: "Réduire les infobulles",
	tipMakeLarge_label: "Agrandir les infobulles",
	// ── Onboarding: the guided first session (js/onboarding.js) ──
	obWelcome_title: "Bienvenue !",
	obWelcomeLang_label: "Je parle :",
	obLevelRow_label: "Votre niveau :",
	obWelcomeBack_tooltip: "Retour à la page d’accueil, pour choisir une autre langue",
	obWelcome_body: "Une courte visite guidée : d’abord, vous découvrez quelques mots, puis l’onglet Pratique vous aide à les retenir pour de bon. Trois minutes seulement. Sans inscription.",
	obLevel_label: "Quel est votre niveau actuel ?",
	obLevelA_button: "Je débute en {0}",
	obLevelB_button: "Je peux tenir une conversation simple",
	obLevelC_button: "Je me débrouille bien, mais je veux enrichir mon vocabulaire",
	obMeet_button: "Visite guidée rapide",
	obMeet_loading: "Chargement de vos premiers mots…",
	obExplore_button: "J’explore par moi-même",
	obGotIt_button: "Compris",
	obBeatBed_title: "Planté !",
	obBeatBed_body: "Vos mots sont maintenant dans votre jardin. Demain, ils seront à arroser — pensez à revenir.",

	// ── Onboarding: the tour that follows the first finished drill (js/onboarding_guide.js) ──
	obTourProgress_title: "Votre progression",
	obTourProgress_body: "Ce panneau tient les comptes dans la durée : mots maîtrisés, précision, quantité de travail accompli.",
	obTourBack_title: "Série terminée",
	obTourBack_body: "« Retour aux mots » quitte la séance et permet de choisir la suite du programme.",
	obTourDict_title: "Le dictionnaire",
	obTourDict_body: "Tout ce qui s’apprend ici possède un article : ouvrez le dictionnaire.",
	// {0} = the language being learned, {1} = a word that IS in the dictionary
	obTourLookup_body: "Saisissez un mot à chercher en {0}, par exemple {1}, puis appuyez sur Entrée.",
	obTourLookup_title: "Chercher un mot",
	obTourLookupPlain_body: "Saisissez un mot à chercher en {0}, puis appuyez sur Entrée.",
	obTourWlAdd_title: "Ajouter à une liste de mots",
	obTourWlAdd_body: "Cliquez sur ce bouton et choisissez une liste : le mot y est ajouté directement. Les listes de mots servent à rassembler exactement les mots à apprendre et à travailler.",
	obTourMyList_title: "Votre liste",
	obTourMyList_body: "Tous les mots et expressions ajoutés à votre liste de mots se trouvent ici. Cliquez dessus pour ouvrir la liste.",
	obTourRowAdd_title: "Envoyer vers Apprendre",
	obTourRowAdd_body: "Ce bouton place le mot sur le plateau Apprendre, prêt pour la prochaine séance.",
	obTourBand_title: "Quelques mots de plus",
	obTourBand_body: "Un seul mot fait une séance bien maigre : ouvrez la liste mise en évidence — celle de votre niveau — et ajoutez d’un coup une poignée de mots au hasard, à apprendre ensemble. Par la suite, vous pourrez aussi choisir chaque mot un par un.",
	obTourBandAdd_title: "Le bouton Ajouter",
	obTourBandAdd_body: "Chaque liste en possède un : il fait passer des mots de la liste vers le plateau. Cliquez dessus.",
	obTourBandRandom_title: "Laissez la liste choisir",
	obTourBandRandom_body: "« Au hasard » tire pour vous une poignée de mots variés : le moyen le plus rapide de remplir une séance.",
	obTourBandFive_title: "En prendre 5",
	obTourBandFive_body: "Cliquez sur la petite flèche à côté du 5 : cinq mots sont tirés au hasard.",
	obTourBandAppend_title: "Garder ce qui est là",
	obTourBandAppend_body: "Le plateau contient déjà un mot. Choisissez la deuxième option : elle ajoute les nouveaux sans supprimer celui-ci.",
	// ── Onboarding: the Word Lists chapter (offered once the first half of the tour ends) ──
	obWlOffer_title: "Tout est prêt",
	obWlOffer_body: "Tout est prêt : cliquez sur « Apprendre ! » et apprenez vos nouveaux mots.\n\nMais avant de poursuivre, laissez-moi vous montrer les listes de mots d’un peu plus près. Il y a beaucoup à y découvrir ! Vous pourrez aussi faire la visite des listes de mots plus tard, depuis le menu d’aide {?}.\n\nVoulez-vous continuer la visite ?",
	obWlOfferNo_button: "Non, je continue par moi-même",
	obWlOfferYes_button: "Oui, montrez-moi les listes de mots",
	obWlPanel_title: "Vos listes de mots",
	obWlPanel_body: "Ce panneau est votre bibliothèque : des listes toutes prêtes tirées du dictionnaire, et celles que vous créez vous-même.",
	obWlGarden_title: "Mon jardin",
	obWlGarden_body: "Chaque mot planté pousse ici, classé selon votre degré de connaissance. Cliquez sur Mon jardin pour l’ouvrir.",
	obWlGardenAuto_title: "Il se remplit seul",
	obWlGardenAuto_body: "Les mots en cours d’apprentissage y sont ajoutés automatiquement — jamais besoin de les ajouter soi-même.",
	obWlLevels_title: "Par fréquence d’usage",
	obWlLevels_body: "Tous les mots du dictionnaire sont répartis en listes par niveau, des plus faciles aux plus difficiles. Cliquez sur une liste pour l’ouvrir et voir ses mots.",
	obWlTopics_title: "Par thème",
	obWlTopicPick_body: "Dix-huit listes derrière une seule ligne — nourriture, voyages, travail, et tout le reste. Cliquez sur celle qui est en surbrillance pour l’ouvrir.",
	obWlTopicWord_title: "Droit à l’article",
	obWlTopicWord_body: "Cliquez sur un mot dans n’importe quelle liste de mots pour voir son article de dictionnaire. Essayez celui qui est en surbrillance.",
	obWlFilter_title: "Trouver un mot",
	obWlFilter_body: "Cliquez sur la loupe pour trouver rapidement des mots dans toutes vos listes de mots.",
	obWlFilterBox_title: "Tapez pour chercher",
	obWlFilterBox_body: "Tapez quelques lettres dans le champ de recherche — elles sont recherchées dans toutes les listes à la fois, et le nombre à côté d'une liste indique combien de ses mots correspondent. Cliquez sur la liste pour les voir. Essayez un mot d'une leçon déjà terminée : vous le trouverez sans doute dans plusieurs listes à la fois.",
	obWlMine_title: "Ma liste",
	obWlMine_body: "⭐ Un mot enregistré depuis le dictionnaire part dans la liste de votre choix — « Ma liste » est là dès le départ, mais vous pourrez aussi créer vos propres listes.",
	obWlNew_title: "Créez la vôtre",
	obWlNew_body: "Cliquez sur ce bouton pour créer une nouvelle liste de mots — rassemblez-y les mots par leçon, par chanson, par thème, comme vous voulez.",
	obWlNewName_title: "Nommez-la",
	obWlNewName_body: "Tapez le nom de votre choix et appuyez sur Entrée.",
	// {0} = the add-to-list icon, inline
	obWlNewUse_title: "Où elle apparaîtra",
	obWlNewUse_body: "La prochaine fois que vous appuierez sur {0} pour un mot à conserver, vous pourrez l’envoyer vers cette liste.",
	obSignReplay_title: "À vous de jouer",
	obSignReplay_body: "<p>Cherchez n'importe quel mot, créez vos propres listes, regardez votre jardin pousser. Et surtout, tapez vos mots dans « Pratique » : ce que vous retrouvez vous-même reste en mémoire.</p><p>Envie de refaire la visite ? Elle est ici, dans ce menu.</p>",

	obTourQuit_title: "Visite en cours",
	obTourQuit_body: "Les autres commandes sont en veille pendant la visite guidée. Voulez-vous terminer la visite et explorer l’application par vous-même ? Vous pourrez relancer la visite à tout moment depuis le menu d’aide {?}.",
	obTourQuitYes_button: "Oui, arrêter la visite",
	obTourQuitNo_button: "Non, continuer la visite",
	obTourQuitRestart_button: "Recommencer la visite",
	obBack_button: "Retour",
	obContinue_button: "Continuer",
	obDoorPractice_title: "Directement à la pratique ?",
	obDoorPractice_body: "Passer directement à la pratique ? La visite continuera là-bas.",
	obDoorPracticeStay_button: "Non, rester dans l’apprentissage",
	obDoorPracticeGo_button: "Oui, à la pratique",
	obDoorDict_title: "Explorer le dictionnaire ?",
	obDoorDict_body: "La visite s’arrêtera, mais vous pourrez la relancer à tout moment depuis le menu d’aide {?}.",
	obDoorDictStay_button: "Retour",
	obDoorDictGo_button: "Ouvrir le dictionnaire",
	// The second line of every card button that carries a recommendation — the quit card's
	// "continue", the welcome card's "meet your first words", the Word Lists offer's "yes".
	obRecommended_hint: "(Recommandé)",

	// ── Onboarding: the entry tour, on the first meet card (js/onboarding_guide.js) ──
	obMeetReveal_title: "Votre premier mot",
	obMeetReveal_body: "Essayez de deviner, puis cliquez sur l’invite — ou appuyez sur Entrée — pour voir ce que le mot signifie.",
	obMeetEntry_title: "Le mot en entier",
	obMeetEntry_body: "Chaque mot que vous découvrez est accompagné d’un article de dictionnaire complet : sens, grammaire, exemples et prononciation. La traduction est en haut, le reste en dessous.",
	// {0} = the meet card's own forward button
	obMeetGotIt_title: "Continuer",
	obMeetGotIt_body: "Cliquez sur « {0} » une fois la lecture terminée.",
	obMeetNext_title: "À vous de jouer",
	obMeetNext_body: "Suivez simplement les instructions à l’écran pour continuer à apprendre vos premiers mots avec Parlevi.",

	// ── Onboarding: beacon tips (js/onboarding_tips.js) ──
	obTipExpLearn_title: "Commencez ici",
	obTipExpLearn_body: "Les nouveaux mots se découvrent dans l’onglet Apprendre. Prenez-en quelques-uns dans les listes de mots à gauche pour démarrer.",
	obTipExpStart_title: "Découvrez vos mots",
	obTipExpStart_body: "<p>Cliquez sur « Apprendre ! » pour découvrir vos premiers mots — tirés au hasard dans votre niveau pour cette première séance. Par la suite, vous choisirez vous-même les mots que vous voulez.</p><p>Une chose encore : pendant la visite, la plus grande partie de l’application est volontairement hors de portée, pour que rien ne détourne du chemin le plus simple. Ensuite, tout est bien sûr à vous.</p>",
	obTipExpDrill_title: "Ils sont prêts",
	obTipExpDrill_body: "Vos mots ont franchi l’étape. Emmenez-les dans Pratique — un court exercice les fixera.",
	obTipExpList_title: "Ouvrir une liste de mots",
	obTipExpList_body: "Cliquez sur cette liste de mots du dictionnaire pour l’ouvrir.",
	obTipExpChip_body: "Cliquez sur cette lettre pour ouvrir la liste de mots la plus facile du dictionnaire.",
	obTipExpAdd_title: "Ajouter quelques mots",
	obTipExpAdd_body: "Ce bouton ajoute des mots de la liste ouverte à votre plateau d’apprentissage — cliquez dessus, puis choisissez combien.",
	obTipExpTray_title: "Vos mots vous attendent",
	obTipExpTray_body: "Les mots que vous avez choisis se trouvent dans votre plateau, dans l’onglet Apprendre, prêts dès que vous l’êtes.",

	// ── Onboarding: the explore glow guide's menu steps (js/onboarding_guide.js) ──
	obGuideRandom_title: "Laissez la liste choisir",
	obGuideRandom_body: "Aléatoire tire pour vous une poignée de mots variés — la façon la plus rapide de commencer.",
	obGuideFive_title: "Commencez avec 3",
	obGuideFive_body: "Cliquez sur la petite flèche et 3 mots tirés au hasard arrivent sur votre plateau d’apprentissage.",
	obGuideFiveNext_title: "5 de plus",
	obGuideFiveNext_body: "Cliquez sur la petite flèche et 5 mots tirés au hasard arrivent sur votre plateau d’apprentissage.",
	obGuideDrill_title: "Travaillez-les",
	obGuideDrill_body: "Cliquez sur « Démarrer l’exercice ! » — une courte séance chronométrée fixera ces mots.",
	// {0} = the language THIS card is answered in (it changes card by card in a Mix session).
	obGuideType_title: "À vous",
	obGuideType_body: "Saisissez ici la traduction en {0}, puis appuyez sur Entrée.",
	// (onboarding ob* keys deliberately absent — FR falls back to English per getRes)
	// ── Mode apprentissage (l'onglet Apprendre) ──
	// ⚠️ The claim that used to sit here — "sans accents, comme le reste du fichier" — was FALSE and
	// was removed 2026-08-28: 91 of the 229 long French values in this file ARE accented, several of
	// them directly below. Two authoring conventions are interleaved throughout, and 174 of the
	// unaccented spots are `a` where French needs `à`, which is a different word (avoir vs the
	// preposition). Do not copy the unaccented style; write correct French.
	learnEmpty_message: "Votre plateau d’apprentissage est vide.",
	quickStart_line: "Prenez des mots dans les listes de mots à gauche — ou piochez {0} mots au hasard ici même :",
	quickStart_count_tooltip: "Nombre de mots ajoutés par bouton",
	quickStart_exhausted_tooltip: "Tous les mots d’ici ont déjà été étudiés — choisissez les vôtres dans les listes de mots à gauche",
	learnStartButton_label: "Apprendre !",
	learnStartButton_tooltip: "Découvrez les nouveaux mots en douceur — sans chrono, sans pression",
	learnClear_tooltip: "Vider le plateau d’apprentissage",
	learnRelearn_button: "Réapprendre",
	learnRelearn_tooltip: "Travailler ces mots prêts encore une fois — l’échelle repart de zéro, leur statut « prêt » ne change pas",
	learnBackToTray_label: "← retour aux mots",
	learnGuided_dots: "Entraînement · 6 tours par mot",
	learnNew_badge: "nouveau",
	learnRow_progress_tooltip: "Déjà commencé — l’échelle reprend où elle s’était arrêtée",
	learnStudyTerm_tooltip: "Cliquez pour ouvrir l’article de dictionnaire de ce mot",
	learnMeet_reveal_label: "Vous connaissez la traduction ? Cliquez ici ou appuyez sur Entrée pour l’afficher",
	learnMeet_gotIt_label: "Compris →",
	learnMeet_fromVerb_label: "du verbe",
	learnQ_meaning: "Que signifie ce mot ?",
	learnQ_pickWord: "Choisissez le mot pour :",
	learnQ_lookalike: "Regardez bien — quel mot signifie :",
	learnQ_whoWhen: "Qui, et quand ?",
	learnQ_whoWhenHint: "le pronom est omis volontairement — c’est la terminaison qui dit qui",
	learnOpt_none: "Aucun de ces mots",
	learnNone_taught: "Exact — le mot n’y était pas.",
	learnQ_phraseMeaning: "Que signifie {0} ici ?",
	learnQ_pickPhrase: "Choisissez l’expression pour :",
	learnQ_pickGap: "Quel mot complète la phrase ?",
	learnQ_typeGapHint: "tapez les {0} premières lettres du mot manquant — il se complétera tout seul",
	learnQ_typeFullGapHint: "tapez seulement le mot manquant — une deuxième erreur de lettre le révèle",
	learnQ_start: "Comment ça commence ?",
	learnQ_typeHint: "tapez les {0} premières lettres — le mot se complétera tout seul",
	learnQ_letterHint: "indice : ça commence par {0}",
	learnQ_letterHintSubst: "indice : ça commence par {0} — taper « {1} » fonctionne aussi",
	learnQ_hearHint: "indice : écoutez — voici le mot",
	learnQ_change: "Qu’est-ce qui change ?",
	learnQ_changeHint: "tapez la partie qui change dans chaque forme",
	learnQ_typeFull: "Tapez maintenant le mot entier",
	learnQ_typeFullHint: "tapez-le de mémoire — une deuxième erreur de lettre le révèle",
	learnQ_repeatWord: "Répétez le mot",
	learnQ_hear: "Qu’avez-vous entendu ?",
	learnQ_pickHint: "Cliquez sur la bonne carte ou tapez son numéro",
	learnFeedback_correct: "Correct !",
	learnFeedback_wrong: "Pas tout à fait",
	learnFeedback_retry: "vous pourrez réessayer",
	learnMiss_settling: "Pas encore ancré — on y reviendra dans un instant.",
	learnMiss_continue: "Continuer →",
	learnSpace_tooltip: "Entrée",
	// ⛔ Pas d'adjectif attribut ici : « prêt » devrait s'accorder avec {0}, qui est un mot du
	// dictionnaire dont le genre en français n'est connu de personne (i18n-runtime-grammar.md §4.4).
	// La tournure verbale supprime la question au lieu de la deviner au masculin.
	learnReady_toast: "{0} peut passer à la Pratique",
	learnRecap_head: "{0} nouveaux mots découverts",
	learnRecap_met: "mots découverts",
	learnRecap_ready: "prêts pour la Pratique",
	learnRecap_time: "durée",
	learnRecap_bridge: "Ils vous attendent sur le plateau de Pratique — le travail les ancre pour de bon.",
	learnRecap_drillNow: "Aller à la Pratique ! →",
	learnRecap_back: "Retour à l’apprentissage",
	learnNudge_message: "Mots tout nouveaux ici : {0} — un premier passage par l’Apprentissage rend la séance de travail bien différente.",
	learnNudge_action: "Les découvrir d’abord",
	learnError_message: "La séance d’apprentissage n’a pas pu démarrer",

	proceed: "Continuer ?",
	error: "Une erreur s’est produite, désolé.\nVeuillez recharger la page",
	stopButton_tooltip: "Cliquez pour arrêter l’exercice et revenir à la page principale",
	langTo_tooltip: "Choisissez la langue que vous souhaitez étudier",
	langFrom_tooltip: "Choisissez votre langue ou une langue que vous connaissez",
	browserTitle_main: "Vocabulaire {0} — {1}",
	enDialectUs_tooltip: "Anglais américain — la voix que vous entendez, la transcription prioritaire et l’accent sur lequel vous êtes évalué",
	enDialectUk_tooltip: "Anglais britannique — la voix que vous entendez, la transcription prioritaire et l’accent sur lequel vous êtes évalué",
	operationCannotComplete_message: "Impossible d’effectuer l’opération",

	myList_create_tooltip: "Créer une nouvelle liste de mots",
	// ── Dictionary direction: the DE⇄EN toggle and the reverse (EN → DE) hit list ──
	// {0} = the language the typed word is expected to be in. Both directions are as-you-type: the
	// forward seek walks the German dictionary, the reverse one walks the tape of English keys
	// (design §9). Enter then focuses the one word, which is what "press Enter" used to mean here.
	lookupField_placeholder_forward: "Commencez à taper un mot en {0} pour trouver son article",
	lookupField_placeholder_reverse: "Commencez à taper un mot en {0} pour trouver les mots qui le traduisent",
	dictDir_forward_tooltip: "Chercher un mot en {0} — la langue que vous apprenez (Alt+1)",
	dictDir_reverse_tooltip: "Chercher un mot en {0} — trouver les mots en {1} qui le traduisent (Alt+2)",
	reverse_intro_message: "Commencez à taper un mot en {0} pour voir les mots en {1} qui le traduisent.",
	startButton_label: "Démarrer l’exercice !",
	startButton_tooltip: "Cliquez pour apprendre des mots !",
	startButton_noWords_message: "Aucun mot n’a été sélectionné pour l’exercice.\nOuvrez une liste de mots à gauche et utilisez « Ajouter à la Pratique ».",
	connUpdating: "Parlevi redémarre. Veuillez patienter une minute.",
	connLost: "Connexion perdue. Vos réponses sont gardées et seront envoyées dès son retour.",
	connNoNewExercise: "Parlevi redémarre. Veuillez réessayer dans une minute.",
	revealWord_label: "Révéler le mot",
	revealWord_tooltip: "Afficher la réponse pour ce mot",
	startButton_wordsInExercise: "Mots pour un exercice :",
	// ── Sens de la pratique (paire de flèches + accolade « mix » + haut-parleur, bande Start) ──
	// Les faces des boutons sont construites avec les codes de langue (« EN → DE ») et ne se
	// traduisent pas ; c'est ici que vit la tâche. {0} = la langue dans laquelle on tape.
	practiceDir_forward_tooltip: "Le sens s’affiche — tapez le mot en {0}<p/>[les deux directions activées = mixte]",
	practiceDir_reverse_tooltip: "Le mot s’affiche — tapez son sens en {0}<p/>[les deux directions activées = mixte]",
	practiceDir_mix_label: "mixte",
	practiceDir_mix_tooltip: "Activez les deux directions pour une séance mixte : chaque mot part dans le sens INVERSE de la dernière fois<p/>(la série garde la même longueur — une carte par mot)",
	practiceDir_mixOff_tooltip: "Une séance mixte demande une pratique par mot entier (une carte par mot)",
	practiceDir_audio_tooltip: "Indice sonore : écouter le mot au lieu de lire le sens<p/>Se combine avec l’une ou l’autre direction",
	practiceDir_locked_tooltip: "C’est la direction utilisée par l’exercice en cours<p/>Arrêtez l’exercice pour la changer",
	// Combined tray view only: distinct words vs total drillable senses ({0} = words, {1} = meanings).
	trayCount_wordsAndMeanings: "{0} mots · {1} sens",
	number_of_words_remaining: "Le nombre de mots restants dans l’exercice en cours",
	pauseButton_label: "Suspendre l’exercice",
	pauseButton_tooltip: "Cliquez pour suspendre l’apprentissage des mots",
	continueButton_label: "Reprendre l’exercice",
	continueButton_tooltip: "Cliquez pour poursuivre l’apprentissage des mots",
	practiceAgainButton_label: "Encore une fois !",
	practiceAgainButton_tooltip: "Refaites la même série — les mots devraient venir du premier coup à présent",
	backToWordsButton_label: "Retour aux mots",
	backToWordsButton_sub: "choisir une nouvelle série",
	stopButton_label: "Arrêter l’exercice",
	stopButton_sub: "(et retour à la page principale)",
	undo_label: "Annuler",
	// The message box's only button (js/msgbox.js). English-only on purpose: getRes falls back
	// to this file, and "OK" is the value in every one of the six locales (see i18n/global*.properties).
	msgOk_button: "OK",
	clearTray_button: "Vider",
	clearTray_tooltip: "Vider le plateau de pratique<p/>(Annuler le restaure)",
	lastFinish_label: "Dernière séance",
	lastFinish_tooltip: "Réafficher le dernier écran de fin de séance",
	trayCapped_message: "Un plateau contient au plus {0} mots — réduit à {2} sur {1}. Travaillez ceux-là d’abord, puis ajoutez le reste.",
	practiceEmpty_message: "Votre plateau de pratique est vide.",
	noWords_message: "Désolé, nous n’avons pas encore de mots pour cette sélection",
	dict_notReady_message: "Le dictionnaire est encore en cours de chargement — un instant…",
	// The flag + language code are prepended as markup, so these carry only the tail: "🇬🇧 EN" + …
	reverse_head_one: "mot · 1 correspondance",
	reverse_head_many: "mot · {0} correspondances",
	reverse_empty_message: "Aucun article pour « {0} »",
	reverse_fallback_message: "Aucun article pour « {0} » — résultats affichés pour",
	reverse_seeAlso_label: "voir aussi :",
	reverse_phrases_label: "Expressions ({0})",
	chooseLangTo_label: "Choisir…",
	chooseLangTo_message: "Choisissez une langue à apprendre",
	noData_message: "Aucune donnée renvoyée par le serveur",
	wlLabel: "Listes de mots",
	wlAddPick_label: "Ajouter à…",
	wlAddPickNew_label: "Nouvelle liste…",
	richTerm_tooltip: "Cliquez pour replier — ou appuyez sur Échap / le bouton Retour du navigateur pour quitter cette vue",
	revealTerm_tooltip: "Cliquez pour ouvrir l’article de dictionnaire — Échap ramène à la carte",
	richEmpty_none: "Pas encore d’article de dictionnaire pour celui-ci.",
	richEmpty_failed: "Impossible de charger l’article de dictionnaire. Vérifiez votre connexion et réessayez.",
	sound_tooltip: "Son<p/>[Raccourci : Espace]",

	pronMic_tooltip: "Entraînez-vous à le prononcer<p/>Ouvre la carte de pratique — maintenez-y le micro et parlez",
	pronHold_tooltip: "Maintenez et parlez, relâchez à la fin",
	pronClose_tooltip: "Fermer",
	pronBest_label: "record",
	pronDialRecognition_label: "Compris",
	pronDialAccent_label: "Accent natif",
	pronDialLegend_label: "anneau extérieur = cet essai · centre = votre record",
	pronDialRecLast_tooltip: "Cet essai — ce qu’un auditeur aurait compris de vos paroles : {0}",
	pronDialRecBest_tooltip: "Votre record de compréhension ici : {0}",
	pronDialAccLast_tooltip: "Cet essai — proximité du son avec celui d’un natif : {0}",
	pronDialAccBest_tooltip: "Votre record d’accent natif ici : {0}",
	pronDialNone_tooltip: "Rien encore prononcé ici",
	pronDialNoBest_tooltip: "Aucun record enregistré",
	pronDialPlay_hint: "cliquez pour écouter",
	pronNoRecording_message: "Aucun enregistrement — votre voix n’est conservée que jusqu’à la fermeture de la page.",
	pronHint_hold: "maintenez pour parler — relâchez à la fin",
	pronHint_recording: "écoute…",
	pronHint_scoring: "évaluation…",
	pronSoundedLike_tip: "sonnait comme /{0}/ là où /{1}/ était attendu",
	pronOmitted_tip: "ce mot n’a pas été entendu",
	pronDiagHeard_text: "entendu : « {0} »",
	pronDiagEarHeard_text: "un auditeur qui ne savait pas à quoi s’attendre a entendu : « {0} »",
	pronDiagPatient_text: "un auditeur patient vous comprend ici ; un auditeur moyen peine",
	pronDiagMissed_text: "n’est pas passé : {0}",
	pronDiagSilence_text: "rien n’a été entendu dans cet enregistrement",
	pronDiagSound_text: "son le plus faible : /{0}/ dans « {1} »",
	pronDiagSoundOnly_text: "son le plus faible : /{0}/",
	pronDiagPart_text: "partie la plus faible : « {0} » dans « {1} »",
	pronDiagPartOnly_text: "partie la plus faible : « {0} »",
	pronDiagWord_text: "mot le plus faible : « {0} »",
	pronExpPartial_text: "une partie n’a pas été prononcée",
	pronExpPauses_text: "de longues pauses entre les mots",
	pronExpFlat_text: "la mélodie est restée plate",
	pronSilent_message: "Cet enregistrement est muet. Le microphone est peut-être coupé ou éteint.",
	pronNoMic_message: "Ce navigateur ne peut pas accéder à un microphone ici.",
	pronRefusalCap_message: "Le quota de pratique de cette semaine est épuisé. Il se recharge une semaine après chaque tentative.",
	pronRefusalUnavailable_message: "L’évaluation de la prononciation n’est pas disponible pour cette langue.",
	pronRefusalAudio_message: "Rien n’a été entendu dans cet enregistrement.",
	pronRefusalNoWord_message: "Ce mot ne figure plus dans le dictionnaire.",
	pronRefusalProvider_message: "L’évaluation n’est pas revenue cette fois-ci.",
	hist_wh_chart_spoken: "Prononciation",
	hist_wh_tip_chart_spoken: "Chaque fois que vous avez prononcé ce mot à voix haute. Un point par tentative, noté d’après le son le plus faible ; la ligne indique votre meilleur résultat jusqu’ici.",
	wlLoad_error_message: "Impossible de charger vos listes de mots",
	wlDelete_error_message: "Impossible de supprimer la liste de mots",
	wlRename_tooltip: "Renommer cette liste de mots",
	wlDelete_tooltip: "Supprimer cette liste de mots",
	wlNoWords_message: "Aucun mot n’est sélectionné",
	wlDeleteWords_tooltip: "Supprimer les mots sélectionnés de cette liste de mots",
	wlCopyWords_tooltip: "Copier les mots sélectionnés vers une autre liste de mots",
	wlCopyNoLists_message: "Vous n’avez qu’une seule liste de mots — créez-en une autre, puis copiez-y les mots sélectionnés",
	wlDeleteWords_error_message: "Impossible de supprimer des mots de la liste de mots",
	wlCannotLoadWords_error_message: "Impossible de charger les mots de la liste de mots",
	wlCannotDeleteWord_error_message: "Impossible de supprimer ce mot de la liste de mots",
	wlCopyWords_error_message: "Impossible de copier les mots vers une autre liste de mots",
	wlAddNoWordList_error_message: "Impossible d’ajouter le mot à une liste de mots — aucune liste n’est sélectionnée",
	wlAdd_error_message: "Impossible d’ajouter le mot à une liste de mots",
	wlVerbs_label: "Formes verbales",
	wlVerbs_tooltip: "Verbes irréguliers, travaillés en une carte par verbe — toutes les formes ensemble",
	wlConjugation_label: "Conjugaison",
	wlConjugation_tooltip: "Verbes, travaillés une forme conjuguée à la fois",
	wlVerbsNoForms_message: "Aucune forme n’a pu être préparée pour ce verbe",
	wlVerbsTruncated_message: "Les {0} premiers verbes sur {1} ont été ajoutés — ajoutez le reste une autre fois",
	wlVerbsExpand_error_message: "Impossible de préparer les formes verbales",
	wlTypedPhrases_label: "Expressions saisies",
	wlTypedPhrases_tooltip: "Les expressions que vous avez saisies et qui ne figurent pas encore dans notre dictionnaire — visibles par vous seul. Les nouvelles arrivent ici automatiquement",
	wlTypedRemove_tooltip: "Retirer de cet historique — les copies dans vos listes restent",
	wlGarden_label: "Mon jardin",
	wlDefault_label: "Ma liste",
	wlGarden_tooltip: "Tous les mots que vous avez réellement abordés — ce qui est à arroser, ce que vous avez commencé et ce qui pousse<p/>Cliquez sur la fleur pour voir tout le jardin",
	wlGardenNeedsWater_tooltip: "{0} mots sont en retard d’arrosage<p/>Ouvrez Mon jardin pour les voir",
	wlGardenWatered_tooltip: "Rien à arroser pour le moment — tout le jardin est à jour",
	wlGardenDifficult_label: "Mots difficiles",
	wlGardenWatering_label: "À arroser",
	wlGardenProgress_label: "Apprentissage",
	wlGardenReady_label: "Prêts pour la pratique",
	wlGardenGrowing_label: "En croissance",
	wlGardenSetAside_label: "Mis de côté",
	wlGardenDifficult_tooltip: "Des mots qui donnent du fil à retordre — travaillez chacun sur 3 jours différents et il quittera cette liste",
	wlGardenWatering_tooltip: "Ces mots sont en retard — arrosez-les maintenant pour qu’ils continuent de pousser",
	wlGardenProgress_tooltip: "Vous avez commencé ces mots dans Apprendre, sans les terminer",
	wlGardenReady_tooltip: "Ces mots sont déjà appris, ils ont maintenant besoin de pratique",
	wlGardenGrowing_tooltip: "Ces mots sont plantés et ne sont pas encore à réviser — le badge compte les jours jusqu’à leur prochaine pratique",
	wlGardenSetAside_tooltip: "Mots mis de côté — ils se reposent ici, sans rien perdre de leurs acquis, jusqu’à ce que vous les réveilliez",
	wlGardenEmpty_message: "Rien ici pour l’instant — apprenez ou travaillez un mot et il apparaîtra dans votre jardin",
	wlGardenSecEmpty_tooltip: "Rien dans cette section pour le moment",
	wlGardenContinueLearn_label: "Continuer l’apprentissage",
	wlGardenAll_disabled_tooltip: "Trop de mots à ajouter d’un coup (max {0}) — utilisez plutôt Aléatoire",
	wlGardenUseSections_note: "Chaque section a un sens différent — ajoutez depuis l’en-tête de la section voulue.",
	wlLevelA_label: "Élémentaire",
	wlLevelB_label: "Débutant",
	wlLevelC_label: "Intermédiaire",
	wlLevelD_label: "Avancé",
	wlLevelE_label: "Expert",
	wlLevelA_tooltip: "Les 1 000 mots les plus fréquents · ≈ CECR A1",
	wlLevelB_tooltip: "Mots 1 001–4 000 · ≈ CECR A2",
	wlLevelC_tooltip: "Mots 4 001–12 000 · ≈ CECR B1",
	wlLevelD_tooltip: "Mots 12 001–24 000 · ≈ CECR B2",
	wlLevelE_tooltip: "Au-delà des 24 000 mots les plus fréquents · ≈ CECR C1–C2",
	// CEFR band slots. The codes are international, so every locale carries them unchanged —
	// genuine identity, not an untranslated placeholder (BundleParityTest guards the key set).
	wlLevelA1_label: "A1",
	wlLevelA2_label: "A2",
	wlLevelB1_label: "B1",
	wlLevelB2_label: "B2",
	wlLevelC1_label: "C1",
	wlLevelC2P_label: "C2+",
	wlLevelA1_tooltip: "Niveau CECR A1 : comprendre et utiliser des expressions courantes du quotidien et des énoncés très simples",
	wlLevelA2_tooltip: "Niveau CECR A2 : comprendre des expressions fréquentes liées à la vie quotidienne — famille, achats, travail, environnement",
	wlLevelB1_tooltip: "Niveau CECR B1 : suivre l’essentiel d’un discours ou d’un texte clair et standard sur des sujets familiers",
	wlLevelB2_tooltip: "Niveau CECR B2 : comprendre les idées principales d’un texte complexe et échanger avec une certaine aisance",
	wlLevelC1_tooltip: "Niveau CECR C1 : comprendre une large gamme de textes longs et exigeants et utiliser la langue avec souplesse",
	wlLevelC2P_tooltip: "Niveau CECR C2 : comprendre sans effort pratiquement tout ce qui est lu ou entendu — plus les mots rares et spécialisés situés au-delà de l’échelle du CECR",
	// Plain-language band names — keys must exist in every locale; real translations exist in
	wlLevelA1_name: "Débutant",
	wlLevelA2_name: "Élémentaire",
	wlLevelB1_name: "Intermédiaire",
	wlLevelB2_name: "Intermédiaire sup.",
	wlLevelC1_name: "Avancé",
	wlLevelC2P_name: "Maîtrise",
	wlLevelSortAlpha_label: "Alphabétique",
	wlLevelSortFreq_label: "Par fréquence d’usage",
	wlLevelSort_tooltip: "Ordre de cette liste — cliquez pour changer",
	wlLevelCompactHint_tooltip: "<p>Double-clic : replier les lignes de niveau en une seule bande.</p><p>Double-cliquez sur le 📖 pour déplier.</p><p>Aussi : menu du compte ▸ Paramètres ▸ Paramètres des listes de mots.</p>",
	wlLevelExpandHint_tooltip: "<p>Double-clic : déplier, une ligne par niveau.</p><p>Double-cliquez sur le 📖 d’une ligne pour replier.</p><p>Cliquez sur une lettre pour ouvrir cette liste.</p><p>Aussi : menu du compte ▸ Paramètres ▸ Paramètres des listes de mots.</p>",
	wlLevelStripCount_tooltip: "Mots du dictionnaire pour cette paire de langues",
	wlVerbCompactHint_tooltip: "<p>Double-clic : replier les lignes de verbes en une seule bande.</p><p>Double-cliquez sur le 📝 pour déplier.</p><p>Aussi : menu du compte ▸ Paramètres ▸ Paramètres des listes de mots.</p>",
	wlVerbExpandHint_tooltip: "<p>Double-clic : déplier, une ligne par liste.</p><p>Double-cliquez sur l’icône d’une ligne pour replier.</p><p>Cliquez sur une icône pour ouvrir cette liste.</p><p>Aussi : menu du compte ▸ Paramètres ▸ Paramètres des listes de mots.</p>",
	wlVerbStripCount_tooltip: "Verbes des deux listes pour cette paire de langues",
	wlTopics_label: "Thèmes",
	wlTopics_tooltip: "Le dictionnaire par situation — choisissez un thème pour ouvrir sa liste de mots",
	wlTopicsPick_label: "Choisir un thème",
	wlTopicsEmpty_message: "Aucun thème pour cette paire de langues pour l’instant",
	richTopicHint_tooltip: "(cliquez pour ouvrir la liste de mots de ce thème)",
	topic_study_label: "Études et éducation",
	topic_travel_label: "Voyages et transports",
	topic_food_label: "Nourriture et boissons",
	topic_health_label: "Santé et corps",
	topic_sport_label: "Sport",
	topic_fashion_label: "Mode et apparence",
	topic_family_label: "Famille et relations",
	topic_work_label: "Travail et carrière",
	topic_politics_label: "Politique et société",
	topic_home_label: "Maison et foyer",
	topic_money_label: "Achats et argent",
	topic_nature_label: "Nature, météo et environnement",
	topic_animals_label: "Animaux",
	topic_tech_label: "Technologie et Internet",
	topic_media_label: "Médias et communication",
	topic_culture_label: "Culture et divertissement",
	topic_feelings_label: "Émotions et caractère",
	topic_law_label: "Droit et criminalité",
	wlAddPractice_button: "Ajouter à Pratique",
	wlAddLearn_button: "Ajouter à Apprentissage",
	wlAddMenuHeader_label: "Ajouter des mots au plateau Pratique",
	wlAddMenuHeaderLearn_label: "Ajouter des mots au plateau Apprentissage",
	wlMenuAll_label: "Tous",
	wlMenuMax_label: "Max ({0} premiers)",
	wlMenuSelected_label: "Sélectionnés",
	wlMenuRandom_label: "Aléatoire",
	wlMenuCountEdit_tooltip: "Modifier le nombre de mots",
	trayReplace_label: "Remplacer dans le plateau {0}",
	trayAppend_label: "Ajouter au plateau {0}",
	trayReplace_math: "(−{0} : +{1})",
	trayAppend_math: "({0} + {1} → {2})",
	trayReplace_tooltip: "Jeter les {0} mots déjà sur le plateau et travailler ces {1} à la place",
	trayAppend_tooltip: "Conserver les {0} mots déjà sur le plateau et ajouter ces {1} — {2} en tout",
	trayAppendUpTo_math: "({0} + {1} max)",
	trayAppendUpTo_tooltip: "Conserver les {0} mots déjà sur le plateau et en ajouter jusqu’à {1} — ceux qui s’y trouvent déjà ne seront pas ajoutés deux fois"
		+ " — ceux qui sont deja dans le plateau ne seront pas ajoutes deux fois",
	trayNothingNew_tooltip: "Ces {0} mots sont déjà tous sur le plateau — il n’y a rien à ajouter",
	trayReplaceVerbs_tooltip: "Jeter ce qui est sur le plateau et travailler ces formes verbales à la place (chaque verbe donne plusieurs cartes, le nombre sera connu une fois qu’elles seront développées)"
		+ " (chaque verbe donne plusieurs cartes, le nombre n'est connu qu'apres le deploiement)",
	trayAppendVerbs_tooltip: "Conserver ce qui est sur le plateau et y ajouter ces formes verbales (chaque verbe donne plusieurs cartes, le nombre sera connu une fois qu’elles seront développées)"
		+ " (chaque verbe donne plusieurs cartes, le nombre n'est connu qu'apres le deploiement)",
	trayFull_tooltip: "Le plateau contient déjà son maximum de {0} mots — remplacez-le, ou videz-en d’abord une partie",
	trayDest_practice: "Pratique",
	trayDest_learn: "Apprentissage",
	trayAddLearn_tooltip: "Ajouter à Apprentissage",
	trayAddPractice_tooltip: "Ajouter à Pratique",
	trayMoveLearn_tooltip: "Déplacer vers Apprentissage",
	trayMovePractice_tooltip: "Déplacer vers Pratique",
	trayAlreadyStaged_toast: "Déjà sur le plateau {0}",
	wlMove_label: "Déplacer vers…",
	wlCopy_label: "Copier vers…",
	wlSelected_label: "sélectionnés",
	wlEmptyList_message: "Aucun mot ici pour l’instant — ajoutez-en depuis le dictionnaire ou d’autres listes de mots",
	wlNewListPlaceholder: "Nom de la nouvelle liste…",
	wlFilterPlaceholder: "Filtrer les mots…",
	wlxGlobalFilter_placeholder: "Trouver un mot dans toutes les listes…",
	wlxGlobalFilter_tooltip: "Rechercher dans toutes les listes de mots",
	wlNoMatch_message: "Aucun mot ne correspond au filtre",
	wlCheckAll_tooltip: "Sélectionner tous les mots",
	wlGardenSecCheckAll_tooltip: "Sélectionner tous les mots de cette section",
	wlWordCount_tooltip: "Nombre de mots dans cette liste",
	wlRowPractice_tooltip: "Ajouter ce mot au plateau Pratique",
	wlRowLearn_tooltip: "Ajouter ce mot au plateau Apprentissage",
	wlRowMoveCopy_tooltip: "Déplacer ou copier ce mot vers une autre liste de mots",
	wlRowRemove_tooltip: "Retirer ce mot de la liste",
	wlRowPark_tooltip: "Mettre ce mot de côté — il cesse de revenir en pratique et conserve tout ce qu’il a acquis, jusqu’à son réveil. Vous le retrouverez dans Mon jardin, dans la bande « Mis de côté » tout en bas",
	wlRowWake_tooltip: "Réveiller ce mot — il reprend la pratique là où il s’était arrêté",
	wlRowUnmarkDifficult_tooltip: "Retirer ce mot des Mots difficiles",
	wlRowDifficultMarks_tooltip: "Travaillé {0} jours sur {1} — travaillez-le {1} jours différents et il quittera cette liste",
	wlRowDifficultHeld_tooltip: "Travaillé {0} jours — les trois jours sont acquis, mais la dernière séance a encore signalé ce mot. Il partira après la première séance qui ne le signalera pas.",
	wlRowDifficultStuck_tooltip: "Travaillé {0} jours et toujours signalé — ce mot demande peut-être un réapprentissage plutôt que davantage de travail. Mettez-le de côté, ou continuez : il partira après la première séance qui ne le signalera pas.",
	wlRowParkFailed_error_message: "Impossible de mettre ce mot de côté",
	trayParkNotStarted_message: "Ce mot n’a pas encore été travaillé, il n’y a donc rien à mettre de côté — retirez-le simplement du plateau",
	trayRemove_tooltip: "Retirer ce mot du plateau",
	scrollUp_tooltip: "Défiler vers le haut",
	scrollDown_tooltip: "Défiler vers le bas",
	knownToggle_tooltip: "Marquer ce sens comme déjà connu — les exercices l’ignorent (recliquer pour annuler)",
	wlSort_tooltip: "Trier vos listes (les listes de mots que vous avez créées vous-même)",
	wlSortNewest_label: "Récentes d’abord",
	wlSortOldest_label: "Anciennes d’abord",
	wlSortAlpha_label: "Alphabétique",
	wlSortSize_label: "Par taille",
	wlBasket_tooltip: "Listes supprimées récemment (corbeille)",
	wlBasketTitle_label: "Supprimées récemment",
	wlBasketEmpty_button: "Vider définitivement",
	wlBasketEmpty_message: "La corbeille est vide",
	wlRestore_button: "Restaurer",
	wlRestore_tooltip: "Restaurer cette liste",
	wlDeleteForever_tooltip: "Supprimer définitivement — action irréversible",
	tzDetected_text: "Détecté",
	settingsTimeZone_tooltip: "Détecté depuis votre navigateur — tout ce que l’application appelle « aujourd’hui » est compté sur cette horloge.<p>À modifier uniquement en cas d’erreur, ou pour garder le calendrier de chez vous pendant un voyage.",
	settingsDayStart_tooltip: "Le moment où votre journée bascule.<p>Avec la valeur par défaut de 03:00, une séance à 1 h du matin compte encore pour la soirée précédente — pratiquer tard ne doit pas vous coûter votre série — et la révision après une nuit de sommeil appartient au jour suivant. Mettez 00:00 pour un minuit strict.",
	signupOptional_tooltip: "L’inscription est facultative.<p> Mais en vous inscrivant, vos listes de mots et vos réglages personnels sont conservés et accessibles depuis n’importe quel ordinateur",
	tsVerbForms_hint: "verbe irrégulier — {0} formes",
	tsWhichVerb_question: "De quel verbe s’agit-il ?",
	tsWhichVerb_hint: "(n’importe quel sens du verbe convient)",
	tsListToSound: "Écoutez — puis tapez la traduction en {0}",
	tsWordNotRetrieved: "Impossible de charger les mots",
	tsAnswerNotSet: "Impossible de préparer la réponse",
	tsYouDoneIt: "Bravo !",
	tsCounterIsZero: "Le compteur est à zéro",
	tsWrong: "Pas tout à fait",
	tsBestAttempt_label: "votre meilleure tentative",
	//Wrong-answer tier phrases (wrong_feedback.js): tier 1 = way off ... tier 5 = almost right.
	tsWrongT1_1: "Oui, celui-là est coriace… prenez votre temps",
	tsWrongT1_2: "Un mot difficile — rien ne presse",
	tsWrongT1_3: "Mot délicat — ne lâchez pas",
	tsWrongT2_1: "Pas encore — continuez",
	tsWrongT2_2: "Encore un essai",
	tsWrongT2_3: "Ça va venir",
	tsWrongT3_1: "Ça chauffe !",
	tsWrongT3_2: "Sur la bonne voie",
	tsWrongT3_3: "Ça progresse — continuez",
	tsWrongT4_1: "Presque !",
	tsWrongT4_2: "Tout près !",
	tsWrongT4_3: "Pas loin !",
	tsWrongT5_1: "Ça y est presque !",
	tsWrongT5_2: "Si près !",
	tsWrongT5_3: "Oh — à un cheveu près !",
	tsSound_tooltip: "Écouter",
	tsReady_tip: "Placez le curseur ici et appuyez sur Entrée pour obtenir le mot suivant de l’exercice",
	tsSelfKnow: "Je comprends",
	tsSelfDontKnow: "Je ne comprends pas",
	tsSelfRight: "J’avais juste",
	tsSelfWrong: "Je me suis trompé",
	tsTypeTranslation_tip: "Tapez ici la traduction correcte en {0}",
	tsTypeWord_tip: "Tapez ici le mot correct en {0}",
	obGuideTypeWord_body: "Saisissez ici le mot en {0}, puis appuyez sur Entrée.",
	obTipSpacePron_title: "Écouter le mot",
	obTipSpacePron_body: "Cliquez sur le bouton haut-parleur pour entendre la prononciation du mot. Il apparaît partout où le mot peut être écouté.",
	obTipThirsty_title: "L’heure d’arroser",
	obTipThirsty_body: "Certaines de vos plantes sont à arroser. Cliquez sur la pastille pour mettre précisément ces mots sur le plateau et faire un tour d’arrosage rapide.",
	obTipDirection_title: "Inverser le sens",
	obTipDirection_body: "Répondez dans la langue que vous apprenez, dans la vôtre — ou mélangez les deux dans une même séance. Le bouton haut-parleur fait travailler l’oreille.",
	obTipMyGarden_title: "Votre jardin est ici",
	obTipMyGarden_body: "Chaque mot planté se retrouve dans Mon jardin — en croissance, à arroser ou en pleine floraison.",
	obTipAddPill_title: "Ajouter des mots",
	obTipAddPill_body: "Ajouter fait passer des mots de cette liste sur votre plateau. Une poignée à la fois, c’est ce qui pousse le mieux.",
	obTipDictLookup_title: "Chercher un mot",
	obTipDictLookup_body: "Saisissez n’importe quel mot dans la langue que vous apprenez — sens, exemples et grammaire inclus.",
	obTipGear_title: "À votre goût",
	obTipGear_body: "Rythme de la séance, répétitions, niveau d’exigence — réglez ici votre pratique.",

	// ── The help hub: the "?" in the tabs row (js/onboarding.js, spec §7) ──
	obHelpMenu_label: "Aide",
	obHelpMenuTip_label: "Astuce du jour",
	obHelpMenuAllTips_label: "Toutes les astuces",
	obHelpMenuReplay_label: "Visite guidée",
	obHelpMenuWlTour_label: "Visite des listes de mots",
	obHelpMenuWelcome_label: "Écran d’accueil",
	// The hub's one setting: guided MODE (tooltip-engine-consolidation.md §4.9). Its row has
	// no label key of its own — it shows tipMakeSmall_label / tipMakeLarge_label, the same two
	// strings the tooltip's corner button uses. NOT the tour's guided RUN.

	// ── Tip of the day (js/tips.js, docs/project/tip-of-the-day.md) ──
	tipDay_title: "Astuce du jour",
	tipsAll_title: "Toutes les astuces",
	tipsClose_label: "Fermer",
	// The interruption is what is switched off, not the tips — hence the toast naming where it
	// went, and hence the switch below saying what it turns back ON.
	tipsOff_toast: "Astuces désactivées. Pour les réactiver : Aide ▸ Toutes les astuces.",
	tipsDaily_label: "Une astuce chaque jour",
	tipsToday_label: "Aujourd’hui",
	// The tease line's speaker. No shortcut in the face, unlike sound_tooltip: Space belongs to
	// the word on the card behind this popup, and claiming it here would take it from there.
	tipTeaseSound_tooltip: "Écouter cette phrase",
	tsDefinitionWasNotSet: "Impossible d’obtenir la définition du mot",
	settings_tooltip: "Réglages",
	prefSpeed_tooltip: "La vitesse du compte à rebours pendant la saisie. Les réponses longues obtiennent plus de temps ; 1 est tranquille, 10 est un sprint.<p>Un mot manqué reçoit du temps supplémentaire à son apparition suivante.",
	prefAdaptiveSpeed_tooltip: "Au sein d’une séance, chaque bonne réponse sur un mot rend son apparition suivante un peu plus rapide — {0} % par cran, jusqu’à {1} crans — et une erreur fait reculer d’un cran. La première apparition d’un mot se déroule toujours à la vitesse normale.",
	prefStrictCaps_tooltip: "Les majuscules comptent : la réponse doit respecter exactement la casse du mot. Désactivé, majuscules et minuscules sont traitées de la même façon.",
	prefDrillArticle_tooltip: "Un nom n’est juste qu’avec son article : <i>der Kunde</i>, et non <i>Kunde</i> seul. L’article fait partie du mot, donc de ce qu’il faut saisir. Désactivé, on saisit le nom seul.",
	prefSelfCheck_tooltip: "Quand le mot s’affiche et que sa signification est demandée, la réponse se fait de tête plutôt qu’au clavier : dites si vous comprenez, découvrez la réponse, puis dites si c’était juste. Désactivé, la signification se saisit au clavier.",
	prefGapPhrases_tooltip: "Une phrase s’affiche sans son mot clé, et il suffit de saisir ce mot. Désactivé, la phrase entière se saisit.<p>Les expressions courtes se saisissent toujours en entier — leur formulation exacte est justement ce qui compte.",
	prefStrictness_tooltip: "Le niveau de preuve exigé pour qu’un mot soit validé et pousse dans votre jardin. À gauche : saisi de mémoire après un coup d'œil à la réponse, ou à peu près juste, et les séances restent courtes. À droite : saisi exactement avant la fin du compte à rebours, et plus d’une fois.<p>La ligne sous le curseur précise le cran choisi.",
	prefVerbOnlyIrregular_tooltip: "La liste Conjugaison ne garde que les verbes irréguliers — ceux dont les formes s’apprennent une à une. Désactivé, elle liste tous les verbes, réguliers compris.",
	prefVerbFullParadigm_tooltip: "Un verbe ajouté depuis la liste Conjugaison apporte tout son tableau — six temps à six personnes, 36 formes. Désactivé, il apporte huit formes clés : présent <i>ich, du, er, wir</i> ; parfait <i>ich, er</i> ; prétérit <i>ich, du</i>.",
	prefVerbPronounPrefill_tooltip: "Sur une carte de conjugaison, le pronom est déjà en place devant le champ de réponse et seule la forme verbale se saisit : <i>ich</i> est donné, <i>fahre</i> se saisit. Désactivé, le pronom se saisit aussi.",
	prefTypedRowOff_tooltip: "Sans effet dans ce sens : ici, on répond par la signification, pas par le mot étudié.",
	prefSelfCheckOff_tooltip: "Sans effet dans ce sens : ici, c’est le mot étudié qui se saisit, il n’y a donc rien à auto-évaluer.",
	ai_unknownWord_error: "« {0} » n’est pas un mot connu en {1}.",
	ai_disabled_error: "La recherche par IA est actuellement indisponible.",
	ai_signIn_error: "Connectez-vous pour rechercher de nouveaux mots aujourd’hui.",
	audio_signIn_message: "Connectez-vous pour continuer à écouter de nouveaux mots.",
	phraseTooLong_message: "C’est un peu trop long pour notre dictionnaire — la limite est de 8 mots et 80 caractères au total.",
	rich_loading_message: "Recherche en cours…",
	rich_failed_message: "Échec de la recherche. Veuillez réessayer.",
	rich_enriching_message: "L’article complet est en préparation…",
	rich_enrichFailed_message: "Pour ce mot, seule la traduction est disponible pour l’instant.",
	// La bande de collocations sous les lignes A–Z (sens direct uniquement).
	phraseBand_words_label: "Dans les mots",
	phraseBand_collocations_label: "Dans les collocations",
	phraseBand_examples_label: "Dans les exemples",
	phraseBand_myPhrases_label: "Dans mes expressions saisies",
	phraseBand_noEntry_message: "Aucun article de dictionnaire pour « {0} »",
	phraseBand_stripOpen_tooltip: "Afficher les résultats",
	phraseBand_stripClose_tooltip: "Masquer ces résultats",
	phraseBand_pagerFirst_tooltip: "Revenir à la première ligne",
	phraseBand_pagerPrev_tooltip: "Reculer de {0} lignes — maintenir pour continuer",
	phraseBand_pagerNext_tooltip: "Avancer de {0} lignes — maintenir pour continuer",
	phraseBand_pagerLast_tooltip: "Aller aux dernières lignes",
	phraseBand_pagerRow_tooltip: "Lignes {0}–{1} sur {2} — cliquer pour y aller",
	// The wrong-toggle nudge: shown INSTEAD of generating an entry, when the typed word is not a
	// word of the language being learned but is a known meaning in the learner's own language.
	dict_wrongDirection_message: "« {0} » ressemble à un mot en {1}.",
	dict_wrongDirection_switch: "Chercher {0} → {1}",
	dict_wrongDirection_anyway: "Non — chercher en {0}",
	dict_openMatch_prefix_message: "Vouliez-vous dire « {0} » ?",
	dict_openMatch_corrected_message: "Affichage de « {0} ».",
	dict_openMatch_lookup_link: "Chercher « {0} » à la place",
	reverse_phrases_shown: "Affichage des {0} premiers résultats sur {1}",
	stats_panel_title: "Ma progression",
	stats_scope_tooltip: "Tout ce que vous avez étudié en {0}. Chaque séance compte, quelle que soit la langue des indices.",
	stats_label_mastered: "mots maîtrisés",
	stats_label_accuracy: "précision",
	stats_label_sessions: "séances",
	stats_label_studied: "étudiés",
	stats_streak: "série de {0} jours",
	stats_best_streak: "record {0}",
	stats_today: "Aujourd’hui : {0} mots · {1}",
	stats_coverage: "{0} des {1} mots les plus fréquents",
	stats_seen: "{0} mots vus",
	stats_learning: "{0} en cours",
	exSummary_flawless: "sans faute",
	exSummary_time: "durée de la séance",
	exSummary_speed: "réponse type",
	exSummary_tricky: "Mots difficiles de cette séance — voulez-vous les ajouter à la liste Mots difficiles ?",
	exSummary_offerDifficult_tooltip: "Ajouter aux Mots difficiles dans Mon jardin",
	exSummary_difficultGraduated: "Ce n’est plus difficile ! 🎉",
	exSummary_difficultProgress: "Beaux progrès sur les mots difficiles !",
	exSummary_difficultFiled: "Ajoutés aux Mots difficiles :",
	exSummary_difficultFiled_shown: "— la réponse a été montrée {0} fois",
	exSummary_difficultFiled_shownFew: "— la réponse a été montrée {0} fois",
	phrasePick_tooltip: "Le travailler en expressions — quelques phrases réelles à choisir",
	phrasePickTitle_label: "« {0} » en expressions",
	phrasePickAdd_label: "À travailler",
	phrasePickDrop_tooltip: "Écarter celle-ci",
	phrasePickRestore_tooltip: "Remettre celle-ci",
	phrasePickNone_message: "Plus aucune expression à ajouter pour « {0} » — soit aucune n’est encore enregistrée, soit vous les avez déjà toutes.",
	phrasePickAdded_message: "Ajouté à vos mots à travailler.",
	exSummary_bridgeMastered: "{0} mots maîtrisés au total",
	exOutcome_recalledCold: "rappelé à froid",
	exOutcome_knownSlow: "connu — rappel lent",
	exOutcome_knownArticle: "connu — article hésitant, le mot lui-même est là",
	exOutcome_warmUp: "échauffement nécessaire",
	exOutcome_relearned: "réponse montrée — revient plus tôt",
	exOutcome_earlyPractice: "un peu arrosé — pleine croissance quand il sera à réviser",
	exOutcome_practiced: "travaillé — la croissance viendra quand il sera à réviser",
	exSummary_grewToday: "Ont poussé aujourd’hui ({0})",
	exSummary_stillGrowing: "En croissance ({0})",
	exOutcome_recalledCold_tooltip: "Première présentation, bonne réponse, immédiatement et sans aide.",
	exOutcome_knownSlow_tooltip: "Le mot est revenu, simplement plus lentement que d’habitude pour ce mot. Cela compte comme un rappel réussi.",
	exOutcome_knownArticle_tooltip: "Le nom est revenu, mais pas l’article. La question a été reposée, mais le mot lui-même compte comme rappelé.",
	exOutcome_warmUp_tooltip: "Pas parfait du premier coup — une petite erreur, ou une réponse arrivée après le délai qui compte comme rappel immédiat. Cela reste un rappel, pas un échec.",
	exOutcome_relearned_tooltip: "Il a fallu montrer la réponse pour que ce mot revienne. Il est reprogrammé plus tôt que prévu.",
	exOutcome_earlyPractice_tooltip: "Ce mot a été travaillé avant son jour d’arrosage. Cela compte, mais la plante franchit son palier à la date indiquée par le badge — travailler en avance ne change rien à cette date.",
	exOutcome_earlyPractice_tooltip_v2: "Ce mot a été travaillé avant son jour d’arrosage. Cela compte, mais le prochain palier de croissance de la plante tombe à une date fixe, sur son propre calendrier, et non à la date indiquée par le badge — seule une réussite à cette date, ou juste avant, permet de le franchir.",
	exOutcome_practiced_tooltip: "Ce mot avait déjà été travaillé aujourd’hui. Un second passage le même jour ne compte pas comme une nouvelle répétition — l’étape suivante arrive au prochain arrosage.",
	exSummary_grewToday_tooltip: "Ces mots ont gagné un palier aujourd’hui — la flèche indique le passage. Une plante pousse quand l’estimation de la durée pendant laquelle vous vous souviendriez encore du mot dépasse le seuil suivant : 1, 3, 7, 14, 30, 60 ou 90 jours.",
	exSummary_stillGrowing_tooltip: "Ces mots ont été arrosés mais ont gardé leur palier, ce qui est le cas ordinaire. Le nombre devant chaque mot indique le prochain arrosage, et il s’éloigne généralement même si l’image reste la même. La plante ne change que lorsque l’estimation dépasse le seuil suivant : 1, 3, 7, 14, 30, 60 ou 90 jours.",
	// The heading those two share for the moment before the server has scored the session — see
	// renderWordSections. It names the only thing known then: which words were drilled.
	exSummary_sessionWords: "Mots de cette séance ({0})",
	exSummary_sessionWords_tooltip: "Tous les mots travaillés pendant cette séance. Ce qui a poussé et ce qui a gardé son palier apparaîtra dans un instant, une fois la séance évaluée.",
	garden_grow_title: "Croissance du jour",
	// The same bed when nothing grew — it still holds every word the session drilled, so it is
	// named for what it honestly is rather than claiming growth that did not happen.
	garden_bed_session: "Mots de cette séance",
	garden_not_planted: "Pas encore planté",
	garden_grow_next: "prochain arrosage dans {0}",
	conj_tense_present: "Présent",
	conj_tense_past: "Passé (prétérit)",
	conj_tense_perfect: "Passé composé",
	conj_tense_past_perfect: "Plus-que-parfait",
	conj_tense_future: "Futur",
	conj_tense_conditional: "Conditionnel",
	// Real French here, not English-verbatim (owner, 2026-08-28: each locale names the tenses the
	// way its own manuals d'allemand do): German textbook term / the French name of the tense.
	conj_tense_present_tip: "Präsens / présent",
	conj_tense_past_tip: "Präteritum / passé simple",
	conj_tense_perfect_tip: "Perfekt / passé composé",
	conj_tense_past_perfect_tip: "Plusquamperfekt / plus-que-parfait",
	conj_tense_future_tip: "Futur / futur",
	conj_tense_conditional_tip: "Konjunktiv II / conditionnel",
	// ── The Spanish conjugation panel (F2a, 2026-09-08) ──────────────────────────────────
	// The nine stored TAMs of register §2.5 plus the RENDERED negative imperative, which is
	// no + the present subjunctive and is never stored. The panel heads its columns with the
	// SPANISH name (Util.paradigmPack.ES in main.js), exactly as the German table heads its
	// own with Präsens; these are the learner-language names — the chip on a card, and the
	// header's hover tip.
	conj_tense_es_pres_ind: "Présent",
	conj_tense_es_pret_ind: "Passé simple",
	conj_tense_es_imp_aff: "Impératif",
	conj_tense_es_imp_neg: "Impératif négatif",
	conj_tense_es_imperf_ind: "Imparfait",
	conj_tense_es_fut_ind: "Futur",
	conj_tense_es_cond: "Conditionnel",
	conj_tense_es_pres_subj: "Subjonctif présent",
	conj_tense_es_imperf_subj_ra: "Subjonctif imparfait (-ra)",
	conj_tense_es_imperf_subj_se: "Subjonctif imparfait (-se)",
	conj_tense_es_pres_ind_tip: "presente / présent",
	conj_tense_es_pret_ind_tip: "pretérito indefinido / passé achevé",
	conj_tense_es_imp_aff_tip: "imperativo / impératif",
	conj_tense_es_imp_neg_tip: "imperativo negativo / no + subjonctif présent",
	conj_tense_es_imperf_ind_tip: "pretérito imperfecto / passé duratif ou habituel",
	conj_tense_es_fut_ind_tip: "futuro simple / futur simple",
	conj_tense_es_cond_tip: "condicional / conditionnel",
	conj_tense_es_pres_subj_tip: "presente de subjuntivo / subjonctif présent",
	conj_tense_es_imperf_subj_ra_tip: "imperfecto de subjuntivo / subjonctif imparfait, forme usuelle",
	conj_tense_es_imperf_subj_se_tip: "imperfecto de subjuntivo / subjonctif imparfait, variante en -se",
	// ── The Spanish FORM KINDS (F2b, 2026-09-08) ─────────────────────────────────────────
	// 77 kinds — 49 simple finite cells, 6 affirmative imperatives, 4 non-finite, 4 nominal,
	// 6 adjectival, 1 derived, 7 determiner/numeral — reached through PosLabel.CANON, exactly
	// like the German block above. ⭐ The _label is the SAME compact code in every bundle: a
	// finite cell names a tense AND a person, which no language abbreviates in five characters,
	// so the chip is Spanish-derived (pr2pl, ra3sg, ip1pl) and the _tooltip is the learner's.
	// Written by analytics/i18n/add_es_form_kind_keys.py — the tense halves are asserted equal
	// to the panel's own conj_tense_es_* values, so one screen never names a tense two ways.
	posVerbPresInd1Sg_label: "pr1sg",
	posVerbPresInd1Sg_tooltip: "Présent, 1re personne du singulier (yo)",
	posVerbPresInd2SgTu_label: "pr2sg",
	posVerbPresInd2SgTu_tooltip: "Présent, 2e personne du singulier (tú)",
	posVerbPresInd2SgVos_label: "prvos",
	posVerbPresInd2SgVos_tooltip: "Présent, 2e personne du singulier, voseo (vos)",
	posVerbPresInd3Sg_label: "pr3sg",
	posVerbPresInd3Sg_tooltip: "Présent, 3e personne du singulier (él, ella, usted)",
	posVerbPresInd1Pl_label: "pr1pl",
	posVerbPresInd1Pl_tooltip: "Présent, 1re personne du pluriel (nosotros)",
	posVerbPresInd2PlVosotros_label: "pr2pl",
	posVerbPresInd2PlVosotros_tooltip: "Présent, 2e personne du pluriel, Espagne (vosotros)",
	posVerbPresInd3Pl_label: "pr3pl",
	posVerbPresInd3Pl_tooltip: "Présent, 3e personne du pluriel (ellos, ellas, ustedes)",
	posVerbPretInd1Sg_label: "pt1sg",
	posVerbPretInd1Sg_tooltip: "Passé simple, 1re personne du singulier (yo)",
	posVerbPretInd2SgTu_label: "pt2sg",
	posVerbPretInd2SgTu_tooltip: "Passé simple, 2e personne du singulier (tú)",
	posVerbPretInd3Sg_label: "pt3sg",
	posVerbPretInd3Sg_tooltip: "Passé simple, 3e personne du singulier (él, ella, usted)",
	posVerbPretInd1Pl_label: "pt1pl",
	posVerbPretInd1Pl_tooltip: "Passé simple, 1re personne du pluriel (nosotros)",
	posVerbPretInd2PlVosotros_label: "pt2pl",
	posVerbPretInd2PlVosotros_tooltip: "Passé simple, 2e personne du pluriel, Espagne (vosotros)",
	posVerbPretInd3Pl_label: "pt3pl",
	posVerbPretInd3Pl_tooltip: "Passé simple, 3e personne du pluriel (ellos, ellas, ustedes)",
	posVerbImperfInd1Sg_label: "im1sg",
	posVerbImperfInd1Sg_tooltip: "Imparfait, 1re personne du singulier (yo)",
	posVerbImperfInd2SgTu_label: "im2sg",
	posVerbImperfInd2SgTu_tooltip: "Imparfait, 2e personne du singulier (tú)",
	posVerbImperfInd3Sg_label: "im3sg",
	posVerbImperfInd3Sg_tooltip: "Imparfait, 3e personne du singulier (él, ella, usted)",
	posVerbImperfInd1Pl_label: "im1pl",
	posVerbImperfInd1Pl_tooltip: "Imparfait, 1re personne du pluriel (nosotros)",
	posVerbImperfInd2PlVosotros_label: "im2pl",
	posVerbImperfInd2PlVosotros_tooltip: "Imparfait, 2e personne du pluriel, Espagne (vosotros)",
	posVerbImperfInd3Pl_label: "im3pl",
	posVerbImperfInd3Pl_tooltip: "Imparfait, 3e personne du pluriel (ellos, ellas, ustedes)",
	posVerbFutInd1Sg_label: "fu1sg",
	posVerbFutInd1Sg_tooltip: "Futur, 1re personne du singulier (yo)",
	posVerbFutInd2SgTu_label: "fu2sg",
	posVerbFutInd2SgTu_tooltip: "Futur, 2e personne du singulier (tú)",
	posVerbFutInd3Sg_label: "fu3sg",
	posVerbFutInd3Sg_tooltip: "Futur, 3e personne du singulier (él, ella, usted)",
	posVerbFutInd1Pl_label: "fu1pl",
	posVerbFutInd1Pl_tooltip: "Futur, 1re personne du pluriel (nosotros)",
	posVerbFutInd2PlVosotros_label: "fu2pl",
	posVerbFutInd2PlVosotros_tooltip: "Futur, 2e personne du pluriel, Espagne (vosotros)",
	posVerbFutInd3Pl_label: "fu3pl",
	posVerbFutInd3Pl_tooltip: "Futur, 3e personne du pluriel (ellos, ellas, ustedes)",
	posVerbCond1Sg_label: "co1sg",
	posVerbCond1Sg_tooltip: "Conditionnel, 1re personne du singulier (yo)",
	posVerbCond2SgTu_label: "co2sg",
	posVerbCond2SgTu_tooltip: "Conditionnel, 2e personne du singulier (tú)",
	posVerbCond3Sg_label: "co3sg",
	posVerbCond3Sg_tooltip: "Conditionnel, 3e personne du singulier (él, ella, usted)",
	posVerbCond1Pl_label: "co1pl",
	posVerbCond1Pl_tooltip: "Conditionnel, 1re personne du pluriel (nosotros)",
	posVerbCond2PlVosotros_label: "co2pl",
	posVerbCond2PlVosotros_tooltip: "Conditionnel, 2e personne du pluriel, Espagne (vosotros)",
	posVerbCond3Pl_label: "co3pl",
	posVerbCond3Pl_tooltip: "Conditionnel, 3e personne du pluriel (ellos, ellas, ustedes)",
	posVerbPresSubj1Sg_label: "sb1sg",
	posVerbPresSubj1Sg_tooltip: "Subjonctif présent, 1re personne du singulier (yo)",
	posVerbPresSubj2SgTu_label: "sb2sg",
	posVerbPresSubj2SgTu_tooltip: "Subjonctif présent, 2e personne du singulier (tú)",
	posVerbPresSubj3Sg_label: "sb3sg",
	posVerbPresSubj3Sg_tooltip: "Subjonctif présent, 3e personne du singulier (él, ella, usted)",
	posVerbPresSubj1Pl_label: "sb1pl",
	posVerbPresSubj1Pl_tooltip: "Subjonctif présent, 1re personne du pluriel (nosotros)",
	posVerbPresSubj2PlVosotros_label: "sb2pl",
	posVerbPresSubj2PlVosotros_tooltip: "Subjonctif présent, 2e personne du pluriel, Espagne (vosotros)",
	posVerbPresSubj3Pl_label: "sb3pl",
	posVerbPresSubj3Pl_tooltip: "Subjonctif présent, 3e personne du pluriel (ellos, ellas, ustedes)",
	posVerbImperfSubjRa1Sg_label: "ra1sg",
	posVerbImperfSubjRa1Sg_tooltip: "Subjonctif imparfait (-ra), 1re personne du singulier (yo)",
	posVerbImperfSubjRa2SgTu_label: "ra2sg",
	posVerbImperfSubjRa2SgTu_tooltip: "Subjonctif imparfait (-ra), 2e personne du singulier (tú)",
	posVerbImperfSubjRa3Sg_label: "ra3sg",
	posVerbImperfSubjRa3Sg_tooltip: "Subjonctif imparfait (-ra), 3e personne du singulier (él, ella, usted)",
	posVerbImperfSubjRa1Pl_label: "ra1pl",
	posVerbImperfSubjRa1Pl_tooltip: "Subjonctif imparfait (-ra), 1re personne du pluriel (nosotros)",
	posVerbImperfSubjRa2PlVosotros_label: "ra2pl",
	posVerbImperfSubjRa2PlVosotros_tooltip: "Subjonctif imparfait (-ra), 2e personne du pluriel, Espagne (vosotros)",
	posVerbImperfSubjRa3Pl_label: "ra3pl",
	posVerbImperfSubjRa3Pl_tooltip: "Subjonctif imparfait (-ra), 3e personne du pluriel (ellos, ellas, ustedes)",
	posVerbImperfSubjSe1Sg_label: "se1sg",
	posVerbImperfSubjSe1Sg_tooltip: "Subjonctif imparfait (-se), 1re personne du singulier (yo)",
	posVerbImperfSubjSe2SgTu_label: "se2sg",
	posVerbImperfSubjSe2SgTu_tooltip: "Subjonctif imparfait (-se), 2e personne du singulier (tú)",
	posVerbImperfSubjSe3Sg_label: "se3sg",
	posVerbImperfSubjSe3Sg_tooltip: "Subjonctif imparfait (-se), 3e personne du singulier (él, ella, usted)",
	posVerbImperfSubjSe1Pl_label: "se1pl",
	posVerbImperfSubjSe1Pl_tooltip: "Subjonctif imparfait (-se), 1re personne du pluriel (nosotros)",
	posVerbImperfSubjSe2PlVosotros_label: "se2pl",
	posVerbImperfSubjSe2PlVosotros_tooltip: "Subjonctif imparfait (-se), 2e personne du pluriel, Espagne (vosotros)",
	posVerbImperfSubjSe3Pl_label: "se3pl",
	posVerbImperfSubjSe3Pl_tooltip: "Subjonctif imparfait (-se), 3e personne du pluriel (ellos, ellas, ustedes)",
	posImpAff2SgTu_label: "ip2sg",
	posImpAff2SgTu_tooltip: "Impératif, 2e personne du singulier (tú)",
	posImpAff2SgVos_label: "ipvos",
	posImpAff2SgVos_tooltip: "Impératif, 2e personne du singulier, voseo (vos)",
	posImpAff3SgUsted_label: "ip3sg",
	posImpAff3SgUsted_tooltip: "Impératif, 3e personne du singulier (usted)",
	posImpAff1Pl_label: "ip1pl",
	posImpAff1Pl_tooltip: "Impératif, 1re personne du pluriel (nosotros)",
	posImpAff2PlVosotros_label: "ip2pl",
	posImpAff2PlVosotros_tooltip: "Impératif, 2e personne du pluriel, Espagne (vosotros)",
	posImpAff3PlUstedes_label: "ip3pl",
	posImpAff3PlUstedes_tooltip: "Impératif, 3e personne du pluriel (ustedes)",
	posInfinitive_label: "inf",
	posInfinitive_tooltip: "infinitif",
	posGerund_label: "ger",
	posGerund_tooltip: "gérondif (-ando / -iendo)",
	posParticiple_label: "part",
	posParticiple_tooltip: "participe passé",
	posParticipleAlt_label: "part2",
	posParticipleAlt_tooltip: "participe passé, seconde forme",
	posNounPlural_label: "pl",
	posNounPlural_tooltip: "pluriel",
	posNounFeminineSg_label: "fsg",
	posNounFeminineSg_tooltip: "féminin singulier, nom",
	posNounFemininePl_label: "fpl",
	posNounFemininePl_tooltip: "féminin pluriel, nom",
	posNounMascPlOfFemHead_label: "mpl",
	posNounMascPlOfFemHead_tooltip: "masculin pluriel d une entrée féminine",
	posAdjFemSg_label: "fsg",
	posAdjFemSg_tooltip: "féminin singulier, adjectif",
	posAdjMascPl_label: "mpl",
	posAdjMascPl_tooltip: "masculin pluriel, adjectif",
	posAdjFemPl_label: "fpl",
	posAdjFemPl_tooltip: "féminin pluriel, adjectif",
	posAdjApocope_label: "apoc",
	posAdjApocope_tooltip: "raccourci devant un nom (gran, buen)",
	posAdjSuperlativoAbsoluto_label: "sup",
	posAdjSuperlativoAbsoluto_tooltip: "superlatif absolu (-ísimo)",
	posAdjSuperlativoAbsolutoAlt_label: "sup2",
	posAdjSuperlativoAbsolutoAlt_tooltip: "superlatif absolu, seconde forme",
	posAdvMente_label: "adv",
	posAdvMente_tooltip: "adverbe en -mente",
	posDetFemSg_label: "fsg",
	posDetFemSg_tooltip: "féminin singulier, déterminant",
	posDetMascPl_label: "mpl",
	posDetMascPl_tooltip: "masculin pluriel, déterminant",
	posDetFemPl_label: "fpl",
	posDetFemPl_tooltip: "féminin pluriel, déterminant",
	posDetNeuter_label: "neut",
	posDetNeuter_tooltip: "forme neutre (lo, esto)",
	posDetApocope_label: "apoc",
	posDetApocope_tooltip: "raccourci devant un nom",
	posNumFeminine_label: "fem",
	posNumFeminine_tooltip: "numéral féminin (una, doscientas)",
	posNumApocope_label: "napo",
	posNumApocope_tooltip: "numéral raccourci (un, cien)",
	conj_person_firstSg: "1re pers. sing.",
	conj_person_secondSg: "2e pers. sing.",
	conj_person_thirdSg: "3e pers. sing.",
	conj_person_firstPl: "1re pers. pl.",
	conj_person_secondPl: "2e pers. pl.",
	conj_person_thirdPl: "3e pers. pl.",

	// ── Règle F7 : la classe d’irrégularité espagnole (F2b, plan §4b ligne 8) ──────────────────
	// Par classe, un `_label` (l’alternance, affichée en pastille) et un `_note` (la ligne qui
	// l’explique). Le verbe d’exemple reste espagnol dans toutes les langues : c’est la langue
	// apprise.
	verb_class_tooltip: "Classe d’irrégularité — comment le radical de ce verbe se modifie. Les cases du présent mises en évidence sont celles qui changent ; les autres suivent le modèle régulier.",
	verbClassOrtografico_label: "orthographe seule",
	verbClassOrtografico_note: "L’orthographe change pour que le son, lui, ne change pas : coger → cojo.",
	verbClassEIe_label: "e → ie",
	verbClassEIe_note: "La voyelle du radical devient une diphtongue sous l’accent : tener → tiene.",
	verbClassOUe_label: "o → ue",
	verbClassOUe_note: "La voyelle du radical devient une diphtongue sous l’accent : llover → llueve.",
	verbClassEI_label: "e → i",
	verbClassEI_note: "La voyelle du radical se ferme sous l’accent : pedir → pide.",
	verbClassEIeI_label: "e → ie / i",
	verbClassEIeI_note: "Diphtongue sous l’accent, voyelle fermée ailleurs : sentir → siente, sintió.",
	verbClassOUeU_label: "o → ue / u",
	verbClassOUeU_note: "Diphtongue sous l’accent, voyelle fermée ailleurs : dormir → duerme, durmió.",
	verbClassZco_label: "-zco",
	verbClassZco_note: "La première personne du singulier se termine en -zco, et tout le subjonctif la suit : conocer → conozco.",
	verbClassIAcento_label: "i → í",
	verbClassIAcento_note: "La voyelle faible prend un accent écrit quand elle est tonique et garde sa syllabe : ampliar → amplío.",
	verbClassUAcento_label: "u → ú",
	verbClassUAcento_note: "La voyelle faible prend un accent écrit quand elle est tonique et garde sa syllabe : actuar → actúo.",
	verbClassEAcento_label: "e → í",
	verbClassEAcento_note: "Le e du radical s’écrit í sous l’accent : reír → río.",
	verbClassIIe_label: "i → ie",
	verbClassIIe_note: "La voyelle du radical devient une diphtongue sous l’accent : adquirir → adquiere.",
	verbClassEYe_label: "e → ye",
	verbClassEYe_note: "En début de mot, la diphtongue s’écrit ye : errar → yerro.",
	verbClassUUe_label: "u → ue",
	verbClassUUe_note: "La voyelle du radical devient une diphtongue sous l’accent : jugar → juega.",
	verbClassOHue_label: "o → hue",
	verbClassOHue_note: "En début de mot, la diphtongue s’écrit hue : oler → huele.",
	// ── SPANISH SENSE FIELDS (S4, 2026-09-08) ───────────────────────────────────────────
	// The copula and position splits, the sense's variety limits, and the shape of a
	// government frame. Region labels are looked up FROM THE CODE — never a prose prefix in
	// a gloss (register clause 14) and never a preposition in a template (a region reads as
	// `label: A, B`, because `en Espagne` / `au Mexique` cannot both come out of one hole).
	senseCopulaSer_label: 'avec ser',
	senseCopulaEstar_label: 'avec estar',
	senseCopulaAmbos_label: 'ser ou estar',
	sensePositionPrenominal_label: 'avant le nom',
	sensePositionPostnominal_label: 'après le nom',
	sensePositionEither_label: 'les deux positions',
	senseRegionTypeOnlyIn_label: 'uniquement',
	senseRegionTypeNotIn_label: 'pas utilisé',
	senseRegionTypePreferredIn_label: 'préféré',
	senseRegionES_label: 'Espagne',
	senseRegionMX_label: 'Mexique',
	senseRegionAR_label: 'Argentine',
	senseRegionUY_label: 'Uruguay',
	senseRegionPY_label: 'Paraguay',
	senseRegionCL_label: 'Chili',
	senseRegionPE_label: 'Pérou',
	senseRegionBO_label: 'Bolivie',
	senseRegionEC_label: 'Équateur',
	senseRegionCO_label: 'Colombie',
	senseRegionVE_label: 'Venezuela',
	senseRegionCR_label: 'Costa Rica',
	senseRegionGT_label: 'Guatemala',
	senseRegionHN_label: 'Honduras',
	senseRegionNI_label: 'Nicaragua',
	senseRegionPA_label: 'Panama',
	senseRegionSV_label: 'Salvador',
	senseRegionCU_label: 'Cuba',
	senseRegionDO_label: 'République dominicaine',
	senseRegionPR_label: 'Porto Rico',
	senseRegionGQ_label: 'Guinée équatoriale',
	senseRegionUS_label: 'États-Unis',
	senseRegionAM_label: 'Amérique',
	senseRegionRPL_label: 'Río de la Plata',
	senseRegionCAM_label: 'Amérique centrale',
	senseRegionAND_label: 'Andes',
	senseRegionCAR_label: 'Caraïbes',
	senseRegionCAN_label: 'Canaries',
	senseConstructionPrepNp_label: '+ nom',
	senseConstructionPrepInf_label: '+ infinitif',
	senseConstructionPrepQueInd_label: '+ que + indicatif',
	senseConstructionPrepQueSubj_label: '+ que + subjonctif',
	senseConstructionQueInd_label: 'que + indicatif',
	senseConstructionQueSubj_label: 'que + subjonctif',
	senseConstructionInfDirecto_label: '+ infinitif direct',
	senseConstructionDativoExperimentante_label: 'expérienceur au datif · me gusta el café',
	senseConstructionObjetoDativo_label: '+ le (objet datif)',
	senseConstructionObjetoAcusativo_label: '+ objet direct',
	senseConstructionSeImpersonal_label: 'se impersonnel',
	senseMoodInd_label: '+ indicatif',
	senseMoodSubj_label: '+ subjonctif',
	rich_perfect_tooltip: "Passé composé — comment ce verbe forme son passé composé : « hat… » avec haben, « ist… » avec sein",

	// ── Historique des sessions (js/session_history.js) ──
	hist_title: "Historique des séances",
	hist_tooltip: "Toutes les séances de pratique terminées avec cette paire",
	hist_back_label: "Retour",
	hist_loading: "Chargement…",
	hist_failed: "Impossible de charger l’historique des séances.",
	hist_empty: "Pas encore de séance de pratique terminée pour cette paire.",
	hist_today: "Aujourd’hui",
	hist_yesterday: "Hier",
	hist_col_time: "Heure",
	hist_col_mastered: "Maîtrisés",
	hist_col_flawless: "Sans faute",
	hist_col_accuracy: "Précision",
	hist_col_shown: "Affichés",
	hist_col_wrong: "Erreurs",
	hist_col_spent: "Durée",
	hist_col_typical: "Habituel",
	hist_of: "sur {0}",
	hist_of_label: "sur",
	hist_stopped: "arrêtée avant la fin",
	hist_dir_mix: "Mixte",
	hist_dir_byEar: "À l’oreille",
	hist_origin_random: "Mots aléatoires",
	hist_origin_search: "Mots recherchés",
	hist_origin_list: "Liste : {0}",
	hist_fact_when: "Quand",
	hist_fact_direction: "Direction",
	hist_fact_source: "Origine des mots",
	hist_fact_set: "Mots de la série",
	hist_fact_shown: "Nombre d’affichages",
	hist_fact_correct: "Bonnes réponses",
	hist_fact_wrong: "Réponse révélée",
	hist_fact_replays: "Réécoutes du son",
	hist_fact_outcome: "Fin",
	hist_outcome_completed: "Terminée",
	hist_outcome_stopped: "Arrêtée avant la fin",
	hist_flawless_legend: "juste à chaque fois — jamais révélé, jamais d’erreur",
	hist_tip_time: "Le moment où cette séance de pratique a commencé.",
	hist_tip_mastered: "Les mots terminés — retirés pour la journée, parmi les mots que la séance devait travailler.",
	hist_tip_flawless: "Les mots justes à chaque présentation : jamais révélés, et sans une seule mauvaise réponse saisie en chemin.",
	hist_tip_accuracy: "Bonnes réponses ÷ présentations. Une présentation se termine soit par une bonne réponse, soit par la révélation de la réponse : voici donc la part trouvée sans aide.",
	hist_tip_shown: "Le nombre de fois où des mots ont été présentés pour une réponse, répétitions comprises.",
	hist_tip_right: "Le nombre de ces présentations auxquelles la bonne réponse a été donnée — quel que soit le nombre d’essais dans le temps imparti.",
	hist_tip_wrong: "Le nombre de présentations qui se sont terminées par la révélation de la réponse : le temps s’est écoulé, ou la réponse a été demandée.",
	hist_tip_spent: "Du premier mot au dernier — toute la séance, pauses comprises.",
	hist_tip_typical: "Le temps qu’une bonne réponse demande d’ordinaire : la valeur médiane sur l’ensemble des mots, pour qu’une longue expression ne fausse pas le résultat.",
	hist_tip_direction: "Le sens dans lequel les questions ont été posées — d’abord la langue de l’indice, puis celle de la réponse.",
	hist_tip_when: "Le jour et l’heure de cette séance, du début à la fin.",
	hist_tip_source: "D’où venaient les mots.",
	hist_tip_set: "Le nombre de mots mis sur le plateau pour cette séance.",
	hist_tip_replays: "Le nombre de fois où le son d’un mot a été réécouté avant de répondre. Une aide demandée, pas une erreur.",
	hist_tip_outcome: "Si la séance est allée jusqu’au bout ou a été arrêtée en cours de route.",
	hist_tip_word: "Le mot dont il est question dans cette ligne. Cliquez sur la ligne pour voir tout son historique d’apprentissage.",
	hist_tip_meaning: "Ce sur quoi la séance a travaillé ce mot — les sens que ses cartes ont réellement demandés.",
	hist_tip_wshown: "Le nombre de fois où ce mot a été présenté pour une réponse.",
	hist_tip_wright: "Le nombre de ces présentations auxquelles la bonne réponse a été donnée, quel que soit le nombre d’essais dans le temps imparti.",
	hist_tip_wwrong: "Le nombre de présentations terminées par la révélation de la réponse — le temps s’est écoulé, ou la réponse a été demandée.",
	hist_tip_wtypical: "Le temps moyen pour trouver la bonne réponse sur ce mot. Les présentations restées sans réponse ne comptent pas.",
	hist_tip_firstTry: "Juste dès la toute première présentation, sans aucune mauvaise réponse saisie — un mot déjà connu. Ce qui s’est passé lors des répétitions n’y change rien.",
	hist_tip_wflawless: "Juste à chaque présentation, jamais révélé et sans aucune mauvaise réponse saisie. Plus strict qu’une première tentative réussie.",
	hist_firstTry_legend: "juste dès le premier affichage — aucune erreur",
	hist_words_none: "Aucun mot n’a été enregistré pour cette séance.",
	hist_words_masteredHead: "Maîtrisés ({0})",
	hist_words_alsoHead: "Aussi travaillés ({0})",
	hist_words_noMatch: "Aucun mot ne correspond à ce filtre.",
	hist_wcol_word: "Mot",
	hist_wcol_meaning: "Sens",
	hist_wcol_firstTry: "1er essai",
	hist_wcol_replays: "Réécoutes",
	hist_wcol_right: "Justes",
	hist_wcol_growth: "Croissance",
	hist_wcol_next: "Revoir",
	hist_wcol_verdict: "Verdict",
	hist_tip_growth: "Votre plante pour ce mot avant et après la séance. Une flèche signifie qu’elle a poussé d’un palier ; une seule plante, estompée, signifie qu’elle est restée au palier où elle était — ce qui est le résultat normal pour un mot travaillé avant d’être à réviser.",
	hist_tip_grew: "Cette séance a fait pousser la plante d’un palier.",
	hist_tip_next: "Le nombre de jours d’attente programmés pour ce mot après cette séance — l’intervalle que l’application acceptait de laisser passer avant de le redemander. Plus il est long, mieux la mémoire tient.",
	hist_tip_next_drawn: "Cette séance a fixé une nouvelle date pour ce mot : {0}.",
	hist_tip_next_held: "Cette séance n’a pas refixé la date — une pratique anticipée ou une reprise le même jour ne touche pas à l’échéance déjà prévue. Toujours à réviser : {0}.",
	hist_tip_verdict: "Ce que le modèle de mémoire a retenu de ce mot ici, dans ses propres termes. Cela peut différer du ressenti pendant l’exercice : un mot arraché de haute lutte peut compter comme retrouvé, et un mot juste peut être enregistré comme lent.",
	hist_days_short: "{0} j",
	hist_v_cold: "rappel immédiat",
	hist_v_slow: "connu, lent",
	hist_v_article: "connu, article",
	hist_v_warmUp: "échauffement",
	hist_v_relearned: "réappris",
	hist_v_early: "anticipé",
	hist_v_sameDay: "même jour",
	hist_vtip_cold: "Le mot est venu tout de suite, du premier coup, sans aide, et l’application n’y a rien vu de lent. Le rappel le plus net qui soit — et c’est lui qui fait passer la plante au palier suivant.",
	hist_vtip_slow: "Le mot est venu sans aide, mais au-delà du temps que l’application accorde pour ce mot — un budget calculé d’après votre vitesse de frappe, et non une horloge fixe. Cela compte comme connu, orthographe presque juste comprise : le souvenir est là, il n’est simplement pas encore rapide.",
	hist_vtip_article: "Le mot lui-même est revenu ; l’article (der / die / das), non. Cela compte comme connaître le mot — c’est le genre qui reste à apprendre, et l’application continue de demander les deux.",
	hist_vtip_warmUp: "Le mot est revenu, mais pas proprement : une orthographe presque juste que l’application a laissée passer, une mauvaise réponse saisie puis corrigée dans la foulée, ou une réponse si lente qu’elle relève de la reconstruction plutôt que du rappel. L’exercice a peut-être quand même montré la réponse en chemin — cette ligne parle de ce qui est revenu, pas de ce qu’a fait l’exercice. Cela reste en deçà d’un rappel net, sans compter pour autant comme un échec.",
	hist_vtip_relearned: "Le mot a été reconstruit plutôt que retrouvé : il n’est pas revenu tout seul cette fois-ci, il vous a donc été remontré pour que vous le reproduisiez. Rien n’est perdu et la plante ne rapetisse jamais — le mot revient simplement plus tôt, et vous repartez d’où vous en étiez.",
	hist_vtip_early: "Vous avez travaillé ce mot avant sa date d’arrosage, et sans vous tromper. Une pratique anticipée compte moins qu’une pratique faite quand le mot est à réviser — la plante peut tout de même monter d’un palier si la mémoire s’est assez consolidée, il faut simplement davantage pour y parvenir.",
	hist_vtip_sameDay: "Ce mot est revenu moins de six heures environ après la dernière fois où il a compté : trop tôt pour prouver quoi que ce soit de nouveau, donc rien n’a été mesuré et rien n’a poussé. La mémoire se consolide dans les intervalles entre les pratiques, pas au sein d’une même séance.",

	// ── Word statistics + one word's history ─────
	hist_ws_title: "Statistiques des mots",
	hist_ws_tooltip: "Tous les mots travaillés avec cette paire — totaux depuis le début, tendances et historique propre à chaque mot",
	hist_ws_empty: "Aucun mot encore travaillé pour cette paire.",
	hist_ws_count: "{0} mots · {1} maîtrisés",
	hist_ws_col_sessions: "Séances",
	hist_ws_col_trend: "Tendance",
	hist_ws_col_mastered: "Maîtrisés",
	hist_ws_mastered_legend: "maîtrisés dans au moins une séance — leur total donne le chiffre de la tuile",
	hist_ws_tip_word: "Le mot dont il est question sur cette ligne. Cliquez sur la ligne pour voir son historique complet.",
	hist_ws_tip_sessions: "Nombre de séances de pratique terminées qui contenaient ce mot.",
	hist_ws_tip_shown: "Nombre de fois où ce mot a été présenté pour une réponse, toutes séances confondues.",
	hist_ws_tip_right: "Présentations où la réponse donnée était correcte, toutes séances confondues.",
	hist_ws_tip_wrong: "Présentations qui se sont terminées par l’affichage de la réponse — temps écoulé, ou réponse demandée.",
	hist_ws_tip_accuracy: "Réponses correctes ÷ présentations, sur tout l’historique du mot.",
	hist_ws_tip_typical: "Votre temps moyen pour une bonne réponse sur ce mot, toutes séances confondues.",
	hist_ws_tip_trend: "Vitesse de réponse, séances récentes comparées aux premières. ▼ signifie plus rapide. Il faut quelques séances chronométrées avant que cela veuille dire quelque chose.",
	hist_ws_tip_mastered: "Mené à terme dans au moins une séance — répondu correctement le nombre de fois requis. Le total de ces lignes donne la tuile « mots maîtrisés ».",
	hist_ws_chart_speed: "Temps de réponse typique par séance",
	hist_ws_tip_chart_speed: "Chaque point est une séance terminée : son temps typique (médiane par mot) pour une bonne réponse. Une courbe qui descend, c’est vous qui accélérez.",
	hist_ws_chart_mastered: "Mots maîtrisés au fil du temps",
	hist_ws_tip_chart_mastered: "Mots maîtrisés, cumulés séance après séance.",
	hist_chart_few: "Pas encore assez de pratique ici pour tracer un graphique.",
	hist_wh_tip_dictionary: "Ouvrir l’article de dictionnaire complet de ce mot.",
	hist_wh_none: "Ce mot n’a pas encore été travaillé.",
	hist_wh_col_when: "Quand",
	hist_wh_tip_when: "La séance qui a travaillé ce mot — son jour et son heure de début. Cliquez sur la ligne pour ouvrir cette séance.",
	hist_wh_firstSeen: "Première pratique",
	hist_wh_tip_firstSeen: "La première séance où ce mot est apparu.",
	hist_wh_lastSeen: "Dernière pratique",
	hist_wh_tip_lastSeen: "La séance la plus récente où ce mot est apparu.",
	hist_wh_stage: "Palier de la plante",
	hist_wh_tip_stage: "La plante de ce mot dans votre jardin — elle pousse d’un palier à chaque révision espacée réussie, jusqu’à 7.",
	hist_wh_due: "Prochain arrosage",
	hist_wh_tip_due: "Le moment où l’application prévoit de revoir ce mot. Les révisions s’espacent de plus en plus à mesure que la mémoire se renforce.",
	hist_wh_overdue: "en retard",
	hist_wh_lapses: "Oublis",
	hist_wh_article: "Article",
	hist_wh_articleNone: "aucun saisi",
	hist_wh_tip_article: "Les fois où vous avez trouvé ce mot mais choisi le mauvais article. Cela compte comme connaître le mot — c’est le genre qui a besoin de pratique, et le travail des articles s’en charge.",
	hist_wh_tip_lapses: "Révisions où le mot s’était échappé et a dû être réappris.",
	hist_wh_chart_speed: "Vitesse de réponse",
	hist_wh_tip_chart_speed: "La courbe est votre temps typique pour une bonne réponse, séance par séance. Les petits points sont les présentations individuelles. Un ✗ en haut signale une présentation où la réponse a dû être dévoilée.",
	hist_wh_chart_gaps: "Jours entre les pratiques",
	hist_wh_tip_chart_gaps: "L’écart avant chaque pratique de ce mot. Des écarts qui s’allongent, c’est une mémoire qui se renforce : l’application ose attendre plus longtemps et le mot est toujours là. La barre en contour est la prochaine révision prévue. La ligne en pointillés indique ce que l’application avait promis à chaque séance — au-dessus de sa barre, cela veut dire que vous êtes revenu plus tôt que nécessaire.",
	hist_wh_scheduled: "prévu",
	hist_wh_chart_stage: "Croissance de la plante",
	hist_wh_tip_chart_stage: "Le palier dans le jardin après chaque révision comptabilisée. Vert : la révision est réussie. Rouge : le mot s’est échappé et la plante a reculé.",
	hist_wh_chart_acc: "Précision par séance",
	hist_wh_tip_chart_acc: "Réponses correctes ÷ présentations, dans chaque séance qui a travaillé ce mot.",
	hist_wh_revealed: "dévoilée",
	hist_wh_pass: "réussie",
	hist_wh_fail: "ratée",
	// ── The accuracy root + the time root ─────────────────
	hist_acc_title: "Précision",
	hist_acc_tooltip: "Comment votre précision se construit et évolue — séance par séance, et les mots qui la font baisser",
	hist_acc_firstTry_lbl: "reconnus d’emblée",
	hist_acc_tip_accuracy: "Bonnes réponses ÷ affichages, sur tout ce qui a été travaillé avec cette paire — le même chiffre que la tuile du panneau.",
	hist_acc_tip_firstTry: "Mots trouvés dès leur toute première apparition, rapportés à l’ensemble des mots présentés au fil de vos séances. L’écart avec votre précision, c’est ce qu’apporte le travail lui-même.",
	hist_acc_tip_chart_bySession: "Bonnes réponses ÷ affichages pour chaque séance terminée, de la plus ancienne à la plus récente.",
	hist_acc_chart_firstTry: "Reconnus d’emblée par séance",
	hist_acc_tip_chart_firstTry: "La part des mots de chaque séance trouvés dès leur toute première apparition — la reconnaissance, avant que le travail ne commence à aider.",
	hist_acc_hard_head: "Mots les plus difficiles ({0})",
	hist_acc_hard_sub: "précision la plus faible, parmi les mots vus au moins {0} fois — cliquez sur un mot pour voir tout son historique",
	hist_acc_hard_none: "Aucun mot ne se détache — aucun mot vu assez souvent n’a une précision faible.",
	hist_time_title: "Temps d’étude",
	hist_time_tooltip: "Où est passé votre temps d’étude — jour par jour, au total, et ce que rapporte une heure de pratique",
	hist_time_typical_lbl: "séance type",
	hist_time_days_lbl: "jours actifs",
	hist_time_tip_total: "La durée de toutes les séances terminées, additionnée. Les pauses au sein d’une séance comptent ; le temps entre les séances, non.",
	hist_time_tip_sessions: "Séances de pratique terminées pour cette paire — le même total que la tuile du panneau.",
	hist_time_tip_typical: "La durée médiane des séances : la moitié d’entre elles ont été plus courtes, l’autre moitié plus longues, si bien qu’une soirée marathon ne fausse rien.",
	hist_time_tip_days: "Jours comptant au moins une séance terminée. Une journée court jusqu’à 3 h du matin : une séance de minuit appartient donc à sa soirée.",
	hist_time_fact_longest: "Séance la plus longue",
	hist_time_tip_longest: "Votre séance la plus longue, et le jour où elle a eu lieu.",
	hist_time_fact_perDay: "Moyenne par jour actif",
	hist_time_tip_perDay: "Temps d’étude total ÷ les jours où vous avez réellement pratiqué.",
	hist_time_fact_perWord: "Par mot maîtrisé",
	hist_time_tip_perWord: "Temps d’étude total ÷ nombre de mots distincts maîtrisés — ce que coûte un mot acquis durablement. Voir ce chiffre baisser, c’est gagné.",
	hist_time_chart_byDay: "Temps de pratique par jour",
	hist_time_tip_chart_byDay: "Minutes de pratique terminée pour chaque jour étudié — les trous sont des jours sans pratique.",
	hist_time_chart_total: "Total des heures au fil du temps",
	hist_time_tip_chart_total: "Temps d’étude cumulé séance après séance. Une habitude régulière donne une pente régulière.",

	// ── "How does my garden grow?" (docs/project/garden-growth-explainer.md) ──
	garden_guide_title: "Comment pousse mon jardin ?",
	garden_guide_open_chip: "Comment pousse mon jardin ?",
	garden_guide_ladder_note: "À compter de la première pratique, chaque arrosage étant fait à temps.",
	garden_guide_ready_note: "La première étape, « Prêt », correspond à un mot déjà appris mais pas encore travaillé : la pousse est déjà visible, mais rien n’est programmé et rien ne compte tant qu’il n’a pas été travaillé une première fois.",
	garden_guide_lead: "Avec de bons soins — environ six mois. Au plus vite, il faut compter à peu près quatre mois.",
	garden_guide_lead_v2: "Avec de bons soins — de sept à neuf mois, en général. Au plus vite, en arrosant pile à temps à chaque étape, il faut compter environ sept mois.",
	garden_guide_how: "Votre plante pousse d’un palier chaque fois que vous l’arrosez <em>au moment où elle le demande</em> et que le mot vous revient encore. Les délais entre deux arrosages sont d’abord minuscules, puis s’allongent à mesure que le mot prend racine : un jour, quelques jours, une semaine, deux semaines, un mois, deux mois. Le halo lumineux est le dernier palier, et il ne veut dire qu’une chose : ce mot a tenu deux mois tout seul et vous le saviez toujours. Ces délais font au total près de quatre mois, même pour un mot qui vous vient sans effort — et environ six pour un mot ordinaire. Un mot récalcitrant prend le temps qu’il faut ; l’application continuera d’y travailler avec vous.",
	garden_guide_how_v2: "Votre plante ne pousse d’un palier que lorsque son propre repère de croissance arrive à échéance — <em>pas simplement parce que vous l’avez arrosée</em>. La mémoire se renforce par étapes qui doublent à peu près : chaque fois qu’un mot vous revient après une pause plus longue, la pause suivante peut sans risque durer environ deux fois plus, si bien que les repères s’échelonnent ainsi : un jour, trois jours, une semaine, deux semaines, un mois, deux mois, un trimestre. Une bonne réponse peu avant un repère le valide quand même — la fenêtre est courte, mais elle existe. Le halo lumineux est le dernier palier, et il ne veut dire qu’une chose : ce mot a tenu un trimestre entier tout seul et vous le saviez toujours. Ces repères font au total près de sept mois, même pour un mot qui les franchit tous pile à temps — et de sept à neuf pour un mot ordinaire, car un repère manqué attend simplement votre prochaine bonne réponse, sans rien coûter au mot. Un mot récalcitrant prend le temps qu’il faut ; l’application continuera d’y travailler avec vous.",
	garden_guide_twoThings: "Deux choses à savoir :",
	garden_guide_hurryHead: "Impossible d’accélérer en arrosant plus.",
	garden_guide_hurryBody: "Travailler un mot dix fois de plus aujourd’hui ne fait rien pousser — l’application sait déjà que vous vous en souvenez <em>aujourd’hui</em>. Ce qu’elle attend de voir, c’est si vous vous en souviendrez la semaine prochaine, puis le mois prochain. La mémoire pousse dans les intervalles, et la plante le montre honnêtement.",
	garden_guide_forgetHead: "Oublier n’est pas un drame.",
	garden_guide_forgetBody: "Si un mot vous échappe, la plante ne rapetisse jamais — elle devient simplement « à arroser » 💧, revient plus tôt, et tout repart d’où vous en étiez.",
	garden_guide_closing: "Alors : plantez-le, arrosez-le quand il le demande, et attendez le halo dans une saison ou deux. Impossible de brusquer les choses — et c’est précisément pour cela que cela a de la valeur. Une fleur lumineuse n’est pas une médaille pour avoir appuyé sur des boutons ; c’est l’application qui vous dit : <em>ce mot est à vous, désormais, pour de bon.</em>",
	garden_guide_closing_v2: "Alors : plantez-le, arrosez-le quand il le demande, et attendez le halo dans deux ou trois saisons. Impossible de brusquer les choses — et c’est précisément pour cela que cela a de la valeur. Une fleur lumineuse n’est pas une médaille pour avoir appuyé sur des boutons ; c’est l’application qui vous dit : <em>ce mot est à vous, désormais, pour de bon.</em>",
	garden_firstplant_card: "Votre premier mot vient de germer 🌱 — voyez comment il pousse jusqu’à la fleur lumineuse.",
	// The day badge's watering tooltip + the plant's click hint.
	garden_water_next: "À arroser de nouveau dans {0} — c’est ce qu’indique le nombre. L’arroser plus tôt ne fait pas pousser la plante plus vite.",
	garden_water_today: "À réviser aujourd’hui — ce mot est prêt à être arrosé. Le point reste vide tant qu’il n’y a pas une journée complète de retard.",
	garden_water_overdue: "En retard depuis {0} — ce mot est à arroser. Rien n’est perdu : la plante ne rapetisse jamais, elle revient simplement plus tôt.",
	// P6 garden growth v2 surfaces (buckets, sprout, soft next-mark words, decision moment)
	garden_sprout_stage_name: "Germe",

	// Les huit échelons de la croissance (garden.js). Termes alignés sur le reste du
	// bundle : « maîtrisé » comme dans hist_ws_count, « Germe » à l'échelon 0 au-dessus.
	garden_ready_stage_name: "Prêt",
	garden_stage1_name: "Vu une fois",
	garden_stage2_name: "Reconnu",
	garden_stage3_name: "Rappelé",
	garden_stage4_name: "Prend racine",
	garden_stage5_name: "Enraciné",
	garden_stage6_name: "Connu",
	garden_stage7_name: "Maîtrisé",
	// The next GROWTH mark, in soft words, appended to the watering badge's tooltip. Five spans
	// since 2026-08-25 (was three): everything past a fortnight used to collapse into "further
	// out", so 30 days and 90 days read the same and "not due to grow yet" looked like a repeated
	// non-answer. Words, never digits — that is what keeps this inside R38's "soft words only".
	// garden.js's SOFT_MARK_SPANS holds the cutoffs (3 / 14 / 45 / 75 days).
	garden_nextMark_fewDays: "Prochain point de croissance : dans quelques jours.",
	garden_nextMark_twoWeeks: "Prochain point de croissance : dans deux semaines environ.",
	garden_nextMark_month: "Prochain point de croissance : dans un mois environ.",
	garden_nextMark_twoMonths: "Prochain point de croissance : dans deux mois environ.",
	garden_nextMark_fewMonths: "Prochain point de croissance : dans quelques mois.",
	// ── the finish screen's three word groups (docs/project/finish-screen-classification.md) ──────
	// ONE axis: the verdict at the user's own strictness notch. The four R13 buckets are still what
	// the server sends and still decide the split INSIDE "Recalled"; they stopped being group names
	// because "Will grow soon" / "Needs sooner watering" describe what the app did, which the user
	// can check and disagree with, while the group is a claim about what they remembered.
	//
	// {1} in the two verdict heads is the linked word — main.js's exStrictnessHead splits the
	// formatted string there and drops an <a> in. Keep {1} in any translation, and inflect
	// exGroup_strictnessWord to match the case the sentence puts it in.
	exGroup_firstWatering: "Premier arrosage ({0})",
	// The one celebratory line on this card (owner, 2026-08-25). Deliberately says nothing about
	// pass or fail: a first practice is a first meeting, so there was nothing to recall yet.
	exGroup_firstWatering_note: "Félicitations — premier arrosage ! Ces pousses ont pris racine et commencent à pousser.",
	exGroup_firstWatering_tooltip: "La première fois que vous travaillez un mot, sa pousse devient une vraie plante : elle prend place dans le calendrier d’arrosage et commence à progresser vers son premier palier de croissance. Rien n’est jugé ici — une première pratique est une première découverte, pas un test de mémoire.",
	exGroup_recalled: "Rappelés — selon votre {1} ({0})",
	exGroup_recalled_tooltip: "Vous avez produit ces mots au niveau que vous avez vous-même fixé avec le curseur du niveau d’exigence. Cliquez sur les mots pour voir ou modifier la position de ce curseur — c’est la seule chose qui détermine dans quel groupe un mot atterrit.",
	exGroup_notDueYet: "La fleur n’a pas encore de palier à atteindre ({0})",
	exGroup_notDueYet_tooltip: "Ces mots sont revenus, et leur fleur n’a tout simplement pas encore de palier de croissance à atteindre. C’est le cas ordinaire, pas un échec : une plante pousse lorsqu’elle atteint son propre palier suivant — 1, 3, 7, 14, 30, 60 ou 90 jours — jamais parce qu’une réponse de plus était juste.",
	exGroup_notRecalled: "Non rappelés — selon votre {1} ({0})",
	exGroup_notRecalled_tooltip: "Ces mots ne sont pas revenus au niveau que vous avez vous-même fixé avec le curseur du niveau d’exigence. Rien n’est perdu et aucune plante ne régresse jamais — ces mots reviennent simplement plus tôt. Cliquez sur les mots pour voir ou modifier la position de ce curseur.",
	exGroup_strictnessWord: "niveau d’exigence",
	exBucket_grew: "Ont poussé aujourd’hui ({0})",
	exBucket_grew_tooltip: "Ces mots ont atteint aujourd’hui leur palier de croissance suivant — un jour fixe sur leur propre calendrier, obtenu par une vraie pratique le jour venu ou après, jamais par l’estimation d’un modèle.",
	exBucket_multiStage: "a franchi plus d’un palier d’un coup",
	decisionMoment_pileUp: "Beaucoup de mots seront à réviser cette semaine par rapport à votre rythme récent. Vous pourriez consacrer un peu plus de temps aux séances, baisser le niveau d’exigence d’un cran ou ralentir l’ajout de nouveaux mots.",
	decisionMoment_headroom: "Votre charge de pratique est légère par rapport à votre rythme récent — il y a de la place pour ajouter des mots, monter le niveau d’exigence d’un cran ou simplement continuer comme cela.",
	garden_day_one: "jour",
	garden_day_few: "jours",
	garden_day_many: "jours",
	garden_stats_click_hint: "Cliquez pour les statistiques de ce mot",
	garden_forms_growing: "{0} formes en croissance",
	garden_grow_from: "étape précédente : {0}",
	garden_grow_open: "Cliquez pour voir tout votre jardin",
	garden_vista_title: "Mon jardin",
	garden_vista_count: "{0} mots plantés",
	garden_vista_empty: "Rien de planté pour l’instant — travaillez un mot et sa première pousse apparaîtra ici.",
	garden_sr_edu: "💡 Arroser deux fois par jour n’accélère pas la croissance — les plantes ont besoin de temps entre deux arrosages.",
	garden_thirsty_chip: "{0} à arroser",
	garden_thirsty_tooltip: "Mots à arroser<p/>Cliquez pour les mettre sur le plateau de pratique",
	// Shown on EVERY press of the chip, not only when something new landed: a press that added
	// nothing (they were all staged already) used to answer with silence and read as a broken
	// button. The sentence is true either way, and it answers the question the press was asking.
	garden_thirstyStaged_toast: "Toutes les plantes à arroser sont sur le plateau, prêtes à être arrosées !",
	garden_open_btn: "Mon jardin",
	garden_open_tooltip: "Tout votre jardin de mots — chaque mot planté, à son palier actuel",
	garden_vista_click_hint: "Cliquez pour l’article complet",

	// ── Feedback : la boîte 💬 (js/feedback.js). EN jusqu'à une passe FR. ──
	feedback_menu: "Envoyer un commentaire",
	feedback_title: "Envoyer un commentaire",
	feedback_type_problem: "Problème",
	feedback_type_dislike: "Je n’aime pas",
	feedback_type_like: "J’aime",
	feedback_type_idea: "Suggestion",
	feedback_type_question: "Question",
	feedback_ph_start: "Choisissez un type ci-dessus, puis écrivez votre message",
	feedback_ph_problem: "Qu’est-ce qui n’a pas fonctionné ?",
	feedback_ph_dislike: "Qu’est-ce qui ne vous plaît pas ?",
	feedback_ph_like: "Qu’est-ce qui vous plaît ?",
	feedback_ph_idea: "Qu’est-ce qui pourrait être mieux ?",
	feedback_ph_question: "Que souhaitez-vous savoir ?",
	feedback_email_label: "E-mail pour une réponse (facultatif)",
	feedback_send: "Envoyer",
	feedback_cancel: "Annuler",
	feedback_thanks: "Merci ! Chaque message est lu.",

	// ── Owner-only word-decision audit table (session-word-audit.md) ──
	audit_title: "Audit des mots",
	audit_none: "Aucun audit n’a été enregistré pour cette séance.",
	audit_empty: "Cette séance ne contient aucun mot audité.",
	audit_finish_tooltip: "Réservé au propriétaire : justification complète des décisions pour chaque mot de cette séance",
	audit_history_chip: "audit",
	audit_y_pass: "réussi",
	audit_y_fail: "échoué",
	audit_y_void: "nul",
	audit_col_seq: "Séq",
	audit_col_outcome: "Résultat",
	audit_col_tier: "Niveau",
	audit_col_latency: "Latence",
	audit_col_shownTs: "Affiché à",
	audit_outcome_PASS: "réussi",
	audit_outcome_FAIL: "échoué",
	audit_outcome_TIMEOUT: "temps écoulé",
	audit_outcome_MEET: "découverte",
	audit_outcome_REVEAL: "révélation",
	audit_acol_attempt: "#",
	audit_acol_submitted: "Saisi",
	audit_acol_correct: "Correct",
	audit_acol_similarity: "Sim",
	audit_acol_errorClass: "Erreur",
	audit_acol_firstKeyMs: "1re touche",
	audit_acol_completionMs: "Achèvement",
	audit_acol_allottedMs: "Alloué",
	audit_acol_keystrokes: "Touches",
	audit_acol_backspaces: "Retours",
	audit_yes: "Oui",
	audit_no: "Non",
	audit_censored: "censuré",
	audit_group_label: "Étiquette",
	audit_group_m5: "M5",
	audit_group_garden: "Jardin",
	audit_f_y: "y",
	audit_f_labelFlags: "Indicateurs",
	audit_f_nPres: "n présentations",
	audit_f_nMin: "n min",
	audit_f_criterionMet: "Critère atteint",
	audit_f_g: "g",
	audit_f_gFinal: "g final",
	audit_f_epsilon: "Epsilon",
	audit_f_lStarMs: "L*",
	audit_f_sBefore: "S avant",
	audit_f_sAfter: "S après",
	audit_f_dAfter: "D après",
	audit_f_rHat: "R̂",
	audit_f_rStar: "R*",
	audit_f_intervalDays: "Δjours",
	audit_f_floored: "Plancher",
	audit_f_dueTs: "À réviser",
	audit_f_algoVersion: "Version algo",
	audit_f_decisionType: "Type de décision",
	audit_f_stageBefore: "Palier avant",
	audit_f_stageAfter: "Palier après",
	audit_f_result: "Résultat",
	audit_f_wasDue: "Était à réviser",
	audit_f_promoted: "Promu",
	audit_f_planted: "Planté",
	audit_f_grew: "A poussé",
	audit_f_lapses: "Oublis",
	// The P4 shadow-verdict strip -- owner-only surface.
	audit_group_verdict: "Verdict",
	audit_group_flower: "Fleur",
	audit_decision_head: "Décision",
	audit_f_notch: "Cran",
	audit_f_band: "bande ≥",
	audit_f_showingsPlanned: "prévues",
	audit_f_bucket: "Panier",
	audit_f_nextMarkDays: "Prochain repère (j)",
	audit_f_otherEngine: "L’autre moteur a dit",
	audit_f_dueModel: "À réviser (modèle)",
	audit_f_nextShown: "Prochaine présentation",
	audit_more_showings: "présentations supplémentaires après le sceau — à titre de preuve uniquement",
	audit_more_details: "Tout le reste (présentations complètes, tous les crans, blocs verbatim)",
	audit_lcol_showings: "Présentations",
	audit_lcol_peeks: "Coups d’œil",
	audit_lcol_time: "Temps",
	audit_lcol_close: "Proximité",
	audit_lcol_rstar: "r*",
	audit_lcol_flower: "Fleur",
	audit_lcol_why: "Pourquoi",
	audit_words_count: "{0} mots",
	audit_grid_mixed: " · crans mixtes",
	audit_gate_perfect: "parfait",
	audit_gate_off_peeks: "Un budget de coups d’œil n’existe que pour la famille A (crans 1–3).",
	audit_gate_off_time: "Purement observationnel — la composition ne lit jamais le cadran du temps. Réel = poids du cran × latence/temps imparti ({0}) de la présentation décisive.",
	audit_gate_off_rstar: "M5 planifié sur r* {0} ; la cible par cran reste inerte jusqu’à la bascule P7.",
	audit_gate_off_close_c: "La famille C ignore la bande : le critère est une présentation parfaite (≥ {0} jamais lu).",
	audit_why_close: "sous la bande à la présentation {0}",
	audit_why_peek: "coups d’œil hors budget à la présentation {0}",
	audit_why_perfect: "pas parfait à la présentation {0}",
	audit_why_void: "scellé nulle part — {0} sur {1} présentées",
	audit_why_pass: "réussi à la présentation {0}",
	audit_why_unknown: "scellé à la présentation {0} — famille non enregistrée",
	audit_v2_title: "v2 (ombre)",
	audit_v2_sealedAt: "Scellé à",
	audit_v2_evid_col_seq: "#",
	audit_v2_evid_col_perfect: "Parfait",
	audit_v2_evid_col_sim: "Sim. preuve",
	audit_v2_evid_col_veto: "Veto",
	audit_v2_guardFlags: "Indicateurs de garde",
	audit_v2_gradedCut: "Seuil gradué",
	// The strictness slider's live caption
	strictness_captionN1: "Vous pouvez voir la réponse jusqu’à deux fois, puis écrire le mot de mémoire — une orthographe très approximative suffit",
	strictness_captionN2: "Vous pouvez voir la réponse une fois, puis écrire le mot de mémoire — une orthographe très approximative suffit",
	strictness_captionN3: "Vous pouvez voir la réponse une fois, puis écrire le mot de mémoire — une orthographe approximative suffit",
	strictness_captionN4: "Écrivez le mot à peu près correctement avant que la réponse ne soit révélée, une fois",
	strictness_captionN5: "Écrivez le mot presque correctement avant que la réponse ne soit révélée, deux fois",
	strictness_captionN6: "Écrivez le mot presque exactement avant que la réponse ne soit révélée, deux fois",
	strictness_captionN7: "Écrivez le mot exactement avant la fin du décompte, deux fois",
	strictness_captionN8: "Écrivez le mot exactement avant la fin du décompte, trois fois",
	strictness_captionN9: "Écrivez le mot exactement avant la fin du décompte, trois fois de suite",
	strictness_captionN10: "Écrivez le mot exactement avant la fin du décompte, à chaque fois sans exception — aucune aide",
	// Part-of-speech labels (pos_label.js) -- pos_label.js real.
	posNoun_label: "nom",
	posNoun_tooltip: "nom",
	posVerb_label: "verbe",
	posVerb_tooltip: "verbe",
	posAdjective_label: "adj",
	posAdjective_tooltip: "adjectif",
	posAdverb_label: "adv",
	posAdverb_tooltip: "adverbe",
	posPhrase_label: "expr",
	posPhrase_tooltip: "expression",
	posPhraseVerbConj_label: "fconj",
	posPhraseVerbConj_tooltip: "forme verbale conjuguée",
	posVerbForms_label: "formes",
	posVerbForms_tooltip: "formes principales du verbe",
	posPreposition_label: "prép",
	posPreposition_tooltip: "préposition",
	posPronoun_label: "pron",
	posPronoun_tooltip: "pronom",
	posConjunction_label: "conj",
	posConjunction_tooltip: "conjonction",
	posInterjection_label: "interj",
	posInterjection_tooltip: "interjection",
	posNumeral_label: "num",
	posNumeral_tooltip: "numéral",
	posArticle_label: "art",
	posArticle_tooltip: "article",
	posDeterminer_label: "dét",
	posDeterminer_tooltip: "déterminant",
	posAbbreviation_label: "abrév",
	posAbbreviation_tooltip: "abréviation",
	posParticle_label: "part",
	posParticle_tooltip: "particule",
	posPrefix_label: "préf",
	posPrefix_tooltip: "préfixe",
	// Form kinds (word_form rows) -- pos_label.js real.
	posPlural_label: "pl",
	posPlural_tooltip: "pluriel",
	posGenitiveSg_label: "gén",
	posGenitiveSg_tooltip: "génitif singulier",
	posDeclined_label: "décl",
	posDeclined_tooltip: "forme déclinée",
	posPast_label: "passé",
	posPast_tooltip: "temps du passé",
	posPreterite_label: "prét",
	posPreterite_tooltip: "prétérit (passé simple)",
	posPastParticiple_label: "ppas",
	posPastParticiple_tooltip: "participe passé",
	posPresent1Sg_label: "1sg",
	posPresent1Sg_tooltip: "présent, 1re personne du singulier",
	posPresent2Sg_label: "2sg",
	posPresent2Sg_tooltip: "présent, 2e personne du singulier",
	posPresent3Sg_label: "3sg",
	posPresent3Sg_tooltip: "présent, 3e personne du singulier",
	posImperative_label: "impér",
	posImperative_tooltip: "impératif",
	posSubjunctiveII_label: "subj2",
	posSubjunctiveII_tooltip: "subjonctif II",
	posSeparableParticle_label: "sép",
	// English placeholder, tracking resources_en.js — ⛔ was 'separable prefix', which named the
	// wrong half of the verb (the row is the finite verb form, not the prefix).
	posSeparableParticle_tooltip: "forme séparable",
	posComparative_label: "comp",
	posComparative_tooltip: "comparatif",
	posSuperlative_label: "sup",
	posSuperlative_tooltip: "superlatif",
	posIngForm_label: "-ing",
	posIngForm_tooltip: "forme en -ing",
	posContraction_label: "contr",
	posContraction_tooltip: "contraction",
	posSuppletive_label: "supp",
	posSuppletive_tooltip: "forme supplétive",
	posProperNoun_label: "npr",
	posProperNoun_tooltip: "nom propre",
	posSpellingVariant_label: "var",
	posSpellingVariant_tooltip: "variante orthographique",
	posFusion_label: "amalg",
	posFusion_tooltip: "forme amalgamée",
	posOther_label: "autre",
	posOther_tooltip: "autre"
};
